//#region IMPORT
/** Components Import */
import {
  Unstable_Grid2 as Grid,
  TextField,
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  InputAdornment,
  Tooltip,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  RadioGroup,
  Chip,
} from '@mui/material';
import {
  PersonAdd as PersonAddIcon,
  AccountCircle as AccountCircleIcon,
} from '@mui/icons-material';
import { Dialog } from '../../../../Components/MUIs';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import dayjs from 'dayjs';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckIcon from '@mui/icons-material/Check';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import RepeatIcon from '@mui/icons-material/Repeat';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import EventIcon from '@mui/icons-material/Event';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TodayIcon from '@mui/icons-material/Today';
import { useEffect, useState } from 'react';
//#endregion

//#endregion

function SCH_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  // 캘린더 이름 편집 상태
  const [editingCalendarId, setEditingCalendarId] = useState(null);
  const [editingDescriptions, setEditingDescriptions] = useState({});
  //#region 함수

  // 기본 캘린더 찾기
  const GetDefaultCalendarId = () => {
    const main = (props.myCalendars || []).find((c) => c.mainCalendar === 'Y');
    const defaultId = main?.calId ?? props.myCalendars?.[0]?.calId ?? '';
    return defaultId ? String(defaultId) : '';
  };

  // 일정 폼 리셋 헬퍼
  const ResetScheduleForm = (date = null) => {
    let base = date ? dayjs(date) : dayjs();

    // 날짜 유효성 검증: 유효하지 않은 날짜면 현재 날짜 사용
    if (!base.isValid()) {
      base = dayjs();
    }

    // 날짜가 0일이거나 잘못된 날짜인 경우 수정
    const dayOfMonth = base.date();
    if (isNaN(dayOfMonth) || dayOfMonth < 1 || dayOfMonth > 31) {
      base = base.date(1);
    }

    // format된 문자열에서 '00'이 포함되어 있는지 확인 (예: 2025-12-00)
    const dateStr = base.format('YYYY-MM-DD');
    if (dateStr.includes('-00')) {
      // 잘못된 날짜를 해당 월의 1일로 수정
      base = base.startOf('month');
    }

    props.setSelectedEvent && props.setSelectedEvent(null);
    props.setScheduleForm({
      title: '',
      description: '',
      location: '',
      isPrivate: false,
      calendarId: props.scheduleForm?.calendarId
        ? String(props.scheduleForm.calendarId)
        : GetDefaultCalendarId(),
      // 신규 일정 등록을 위해 calEId와 calReId를 0으로 명확히 리셋
      calEId: 0,
      calReId: 0,
      startDate: base,
      endDate: base.add(1, 'hour'),
      isAllDay: false,
      isRepeat: false,
      alarmYn: false,
      alarms: [],
      isEventOwner: true, // 신규 등록 시에는 항상 작성자
    });
    // 반복 설정도 함께 리셋
    props.setRepeatSettings &&
      props.setRepeatSettings({
        type: '',
        interval: 0,
        daysOfWeek: [],
        monthlyType: '',
        dayOfMonth: 0,
        weekOfMonth: 0,
        dayOfWeek: 0,
        monthOfYear: 0,
        endType: '',
        endDate: null,
        endCount: null,
        calReId: '',
        calEId: '',
      });
  };

  // 일정 클릭 시 상세 팝업 열기 (조회 모드)
  const HandleEventClick = (ev, e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const start = ev.start || ev.startDt;
    const end = ev.end || ev.endDt || start;
    const allDay = ev.allDay || ev.allDay === true || ev.allDay === 'Y';

    // 조회된 일정의 calId를 우선적으로 사용
    // calId, calId 순서로 확인하고, 타입을 일관되게 처리 (문자열로 통일)
    const eventCalendarId = ev.calId ?? null;
    // myCalendars에 해당 calId가 존재하는지 확인하고, 문자열로 변환
    const foundMyCalendar = (props.myCalendars || []).find(
      (cal) =>
        String(cal.calId) === String(eventCalendarId) ||
        cal.calId === eventCalendarId
    );
    const validCalendarId =
      eventCalendarId !== null &&
      eventCalendarId !== undefined &&
      eventCalendarId !== ''
        ? foundMyCalendar
          ? String(foundMyCalendar.calId)
          : String(eventCalendarId)
        : null;

    // 작성자 확인: 내 캘린더에 속한 일정이면 로그인한 유저가 작성자
    // 공유 캘린더에 속한 일정이면 다른 사람이 작성자
    const isMyCalendar = !!foundMyCalendar;
    const isEventOwner = isMyCalendar && props.userInfo?.userid;

    // 알람 정보 처리
    const hasAlarm =
      ev.alarmId != null && ev.alarmId !== '' && ev.alarmId !== 0;
    const alarmValue = ev.alarmValue != null ? Number(ev.alarmValue) : null;
    const alarmUnitText = ev.alarmUnitText || '';

    // 알람 단위 텍스트를 타입으로 변환
    const alarmTypeMap = {
      분전: 'minutes',
      시간전: 'hours',
      일전: 'days',
      주전: 'weeks',
    };
    const alarmType = alarmTypeMap[alarmUnitText] || 'minutes';
    props.setScheduleForm((prev) => ({
      ...prev,
      title: ev.title || '',
      description: ev.description || '',
      location: ev.location || '',
      // 문자열도 처리할 수 있도록 명시적으로 boolean 변환
      isPrivate: ev.visibility === '1',
      calendarId:
        validCalendarId ??
        (prev.calendarId ? String(prev.calendarId) : null) ??
        String(GetDefaultCalendarId() ?? ''),
      calEId:
        ev.calEId != null &&
        ev.calEId !== '' &&
        ev.calEId !== 0 &&
        ev.calEId !== '0'
          ? String(ev.calEId)
          : '',
      calReId:
        (ev.calREId != null &&
          ev.calREId !== '' &&
          ev.calREId !== 0 &&
          ev.calREId !== '0') ||
        (ev.calReId != null &&
          ev.calReId !== '' &&
          ev.calReId !== 0 &&
          ev.calReId !== '0')
          ? String(ev.calREId || ev.calReId)
          : '',
      startDate: start,
      endDate: end,
      isAllDay: !!allDay,
      isRepeat: !!(
        ev.recurrenceType ||
        ev.recurrenceInterval ||
        ev.byWeekDay ||
        ev.byMonthDay ||
        ev.recurrenceUntil ||
        ev.recurrence_count
      ),
      alarmYn: hasAlarm,
      alarms:
        hasAlarm && alarmValue != null
          ? [
              {
                id: 'default',
                minutes: alarmValue,
                type: alarmType,
              },
            ]
          : [],
      isEventOwner: isEventOwner, // 작성자 여부 저장
    }));

    // 반복 설정 매핑: ev 구조 기준
    try {
      const typeRaw = (ev.recurrenceType || '').toString().toUpperCase();
      const typeMap = {
        DAILY: 'daily',
        WEEKLY: 'weekly',
        MONTHLY: 'monthly',
        YEARLY: 'yearly',
      };
      const type = typeMap[typeRaw] || '';
      const interval = Number(ev.recurrenceInterval || 1) || 1;
      const byWeekDay = (ev.byWeekDay || '').toString(); // e.g. "MO,WE,FR"
      const byMonthDay = ev.byMonthDay != null ? Number(ev.byMonthDay) : null;
      // 종료 타입 추론
      const endType = ev.recurrenceUntil
        ? 'UNTIL'
        : Number(ev.recurrence_count || 0) > 0
          ? 'COUNT'
          : 'NEVER';
      const endCount = Number(ev.recurrence_count || 0) || 0;
      const until = ev.recurrenceUntil ? dayjs(ev.recurrenceUntil) : null;

      // 요일 문자열 -> 인덱스 배열(SU=0..SA=6)
      const weekMap = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 };
      const daysOfWeek = byWeekDay
        .split(',')
        .map((s) => s.trim().toUpperCase())
        .filter((s) => weekMap[s] != null)
        .map((s) => weekMap[s]);

      // monthlyType 및 dayOfMonth 결정
      let monthlyType = '';
      let dayOfMonth = 1;
      if (type === 'monthly') {
        if (byMonthDay && !isNaN(byMonthDay)) {
          monthlyType = 'day';
          dayOfMonth = byMonthDay;
        }
      }

      props.setRepeatSettings((prev) => ({
        ...prev,
        type,
        interval,
        daysOfWeek: daysOfWeek.length > 0 ? daysOfWeek : prev.daysOfWeek || [],
        monthlyType,
        dayOfMonth,
        weekOfMonth: prev.weekOfMonth || 1,
        dayOfWeek: prev.dayOfWeek || 0,
        monthOfYear: prev.monthOfYear || 1,
        endType,
        endDate: endType === 'UNTIL' && until ? until : null,
        endCount: endType === 'COUNT' ? endCount : null,
        calREId: ev.calREId || prev.calReId || '',
      }));
    } catch (err) {
      // 반복 매핑 실패 시 무시
    }
    props.setScheduleDetailPopupOpen(true);
  };

  /// 색상 선택 토글 함수 (클릭 위치 저장)
  const HandleColorPickerToggle = (calendarId, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    props.setColorPickerOpen((prev) => ({
      ...prev,
      [calendarId]: {
        isOpen: !prev[calendarId]?.isOpen,
        position: {
          top: rect.bottom + 5,
          left: rect.left,
          right: rect.right,
        },
      },
    }));
  };
  // 공유캘린더 색상 선택 토글 함수
  const HandleSharedColorPickerToggle = (sharedCalendarId, event) => {
    // 신청대기 상태인 공유 캘린더인지 확인
    const calendar = props.sharedCalendars.find(
      (cal) => cal.calMId === sharedCalendarId || cal.id === sharedCalendarId
    );
    if (calendar && (calendar.isWait === '0' || calendar.isWait === 0)) {
      return; // 신청대기 상태면 색상 변경 불가
    }

    const rect = event.currentTarget.getBoundingClientRect();
    props.setColorPickerOpen((prev) => ({
      ...prev,
      [sharedCalendarId]: {
        isOpen: !prev[sharedCalendarId]?.isOpen,
        position: {
          top: rect.bottom + 5,
          left: rect.left,
          right: rect.right,
        },
      },
    }));
  };

  // 공유캘린더 색상 변경 함수
  const HandleSharedColorChange = (sharedCalendarId, newColor) => {
    props.UpdateSharedCalendarColorLogic(sharedCalendarId, newColor);
    props.setColorPickerOpen((prev) => ({
      ...prev,
      [sharedCalendarId]: { ...prev[sharedCalendarId], isOpen: false },
    }));
  };

  // 모든 색상 팔레트 닫기 함수
  const HandleCloseAllColorPickers = () => {
    props.setColorPickerOpen({});
  };
  // 색상 변경 함수
  const HandleColorChange = (calendarId, newColor) => {
    props.UpdateCalendarColorLogic(calendarId, newColor);
    props.setColorPickerOpen((prev) => ({
      ...prev,
      [calendarId]: { ...prev[calendarId], isOpen: false },
    }));
  };
  // 외부 클릭 감지 함수
  const HandleOutsideClick = (event) => {
    const hasOpenPicker = Object.values(props.colorPickerOpen).some(
      (picker) => picker?.isOpen
    );

    if (hasOpenPicker) {
      const isColorPickerClick =
        event.target.closest('[data-color-picker]') ||
        event.target.closest('[data-color-box]');

      if (!isColorPickerClick) {
        props.setColorPickerOpen({});
      }
    }
  };

  // useEffect로 외부 클릭 이벤트 리스너 추가
  useEffect(() => {
    document.addEventListener('click', HandleOutsideClick);

    return () => {
      document.removeEventListener('click', HandleOutsideClick);
    };
  }, [props.colorPickerOpen]);

  // 신청대기 상태인 공유 캘린더의 색상 팔레트 자동으로 닫기
  useEffect(() => {
    if (props.sharedCalendars && props.sharedCalendars.length > 0) {
      const hasOpenPicker = Object.entries(props.colorPickerOpen || {}).some(
        ([key, value]) => value?.isOpen
      );

      if (hasOpenPicker) {
        const pendingCalendars = props.sharedCalendars.filter(
          (cal) => cal.isWait === '0' || cal.isWait === 0
        );

        if (pendingCalendars.length > 0) {
          // 신청대기 상태인 캘린더의 팔레트 닫기
          const updatedColorPickerOpen = { ...props.colorPickerOpen };
          let shouldUpdate = false;

          pendingCalendars.forEach((cal) => {
            const calMId = cal.calMId || cal.id;
            if (updatedColorPickerOpen[calMId]?.isOpen) {
              updatedColorPickerOpen[calMId] = {
                ...updatedColorPickerOpen[calMId],
                isOpen: false,
              };
              shouldUpdate = true;
            }
          });

          if (shouldUpdate) {
            props.setColorPickerOpen(updatedColorPickerOpen);
          }
        }
      }
    }
  }, [props.sharedCalendars]);

  // 캘린더 환경설정 팝업이 열릴 때 데이터 조회
  useEffect(() => {
    if (props.modalToggle2) {
      // 내 캘린더 탭일 때는 내 캘린더 데이터 재조회
      if (props.calendarManagementTab === 0) {
        props.SearchCalendarLogic?.();
      }
      // 공유 캘린더 탭일 때는 공유 캘린더 데이터 조회
      else if (props.calendarManagementTab === 1) {
        props.SearchCalendarManagementData?.(
          props.favoriteCalendarView || 'myFavorites'
        );
      }
    }
  }, [props.modalToggle2, props.calendarManagementTab]);

  // 캘린더 저장 함수
  const HandleCalendarSave = () => {
    if (!props.calendarForm.description.trim()) {
      dispatch(
        showSnackbar({
          message: '캘린더명을 입력해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    // editingCalendar 파라미터 추가
    props.SaveCalendarLogic(props.calendarForm, props.editingCalendar, () => {
      props.setCalendarPopupOpen(false);
      props.setCalendarForm({
        description: '',
        color: '#6aa84f',
        isPublic: '0',
        calId: '',
      });
      props.setEditingCalendar(null); // 편집 상태 초기화
    });
  };

  // 수정 모드 토글
  const HandleEditModeToggle = () => {
    props.setIsEditMode((prev) => !prev);
    if (props.isEditMode) {
      props.setPendingDeleteCalendars([]);
    }
  };

  // 캘린더를 삭제 대기 상태로 추가
  const HandleMarkForDelete = (calendarId) => {
    props.setPendingDeleteCalendars((prev) => [...prev, calendarId]);
  };

  // 삭제 대기 상태 취소 (새로고침)
  const HandleCancelDelete = () => {
    props.setPendingDeleteCalendars([]);
    dispatch(
      showSnackbar({
        message: '삭제가 취소되었습니다.',
        type: 'info',
      })
    );
  };

  // 최종 삭제 확인
  const HandleConfirmDelete = () => {
    if (props.pendingDeleteCalendars.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 캘린더가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // 메인 캘린더 삭제 방지 체크
    const mainCalendarsToDelete = props.pendingDeleteCalendars.filter((id) => {
      const calendar = (props.myCalendars || []).find(
        (cal) => cal.calId === id || String(cal.calId) === String(id)
      );
      return calendar && calendar.mainCalendar === 'Y';
    });

    if (mainCalendarsToDelete.length > 0) {
      dispatch(
        showSnackbar({
          message: '메인캘린더는 삭제할 수 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // DB에서 삭제
    props.DeleteCalendarLogic(props.pendingDeleteCalendars);

    // 로컬 상태 초기화
    props.setPendingDeleteCalendars([]);
    props.setIsEditMode(false);
  };

  // 캘린더 체크 토글 (캘린더ID, 내캘린더여부 (true:내캘린더, false:관심캘린더))
  const HandleCalendarToggle = async (calendarId, isMyCalendar = true) => {
    if (isMyCalendar) {
      // 현재 체크 상태 확인
      const currentCalendar = props.myCalendars.find(
        (cal) => cal.calId === calendarId || cal.id === calendarId
      );
      const newCheckedState = !currentCalendar?.checked;

      // 프로시저 호출 먼저 수행 (UI는 프로시저 성공 후 업데이트)
      try {
        await props.UpdateCalendarPublicLogic(calendarId, newCheckedState);

        // 프로시저 성공 후 UI 업데이트 및 일정 재조회
        props.setMyCalendars((prev) =>
          prev.map((cal) =>
            cal.calId === calendarId || cal.id === calendarId
              ? { ...cal, checked: newCheckedState }
              : cal
          )
        );
      } catch (e) {
        // 실패 시 원래 상태로 롤백
        props.setMyCalendars((prev) =>
          prev.map((cal) =>
            cal.calId === calendarId || cal.id === calendarId
              ? { ...cal, checked: !newCheckedState }
              : cal
          )
        );
      }
    } else {
      // 공유 캘린더 로직 추가
      // calMId만 정확히 비교 (타입 변환 고려)
      const currentCalendar = props.sharedCalendars.find(
        (cal) =>
          String(cal.calMId) === String(calendarId) ||
          Number(cal.calMId) === Number(calendarId) ||
          cal.calMId === calendarId
      );

      // 신청대기 상태인 경우 체크 불가
      if (
        currentCalendar &&
        (currentCalendar.isWait === '0' || currentCalendar.isWait === 0)
      ) {
        return;
      }

      if (!currentCalendar) {
        console.error('공유 캘린더를 찾을 수 없습니다:', calendarId);
        console.error('전체 공유 캘린더 목록:', props.sharedCalendars);
        return;
      }

      const newCheckedState = !currentCalendar?.checked;

      // 프로시저 호출 먼저 수행 (UI는 프로시저 성공 후 업데이트)
      try {
        await props.UpdateSharedCalendarPublicLogic(
          calendarId,
          newCheckedState
        );

        // 프로시저 성공 후 UI 업데이트 및 일정 재조회
        props.setSharedCalendars((prev) =>
          prev.map((cal) =>
            String(cal.calMId) === String(calendarId) ||
            Number(cal.calMId) === Number(calendarId) ||
            cal.calMId === calendarId
              ? { ...cal, checked: newCheckedState }
              : cal
          )
        );
      } catch (e) {
        // 실패 시 원래 상태로 롤백 - calMId만 정확히 비교 (타입 변환 고려)
        props.setSharedCalendars((prev) =>
          prev.map((cal) =>
            String(cal.calMId) === String(calendarId) ||
            Number(cal.calMId) === Number(calendarId) ||
            cal.calMId === calendarId
              ? { ...cal, checked: !newCheckedState }
              : cal
          )
        );
      }
    }
  };

  // 공유캘린더 수정 모드 토글
  const HandleSharedEditModeToggle = () => {
    props.setIsSharedEditMode((prev) => !prev);
    if (props.isSharedEditMode) {
      props.setPendingDeleteSharedCalendars([]);
    }
  };

  // 공유캘린더를 삭제 대기 상태로 추가
  const HandleMarkSharedForDelete = (sharedCalendar) => {
    props.setPendingDeleteSharedCalendars((prev) => [...prev, sharedCalendar]);
  };

  // 공유캘린더 삭제 대기 상태 취소 (새로고침)
  const HandleCancelSharedDelete = () => {
    props.setPendingDeleteSharedCalendars([]);
    dispatch(
      showSnackbar({
        message: '삭제가 취소되었습니다.',
        type: 'info',
      })
    );
  };

  // 공유캘린더 최종 삭제 확인
  const HandleConfirmSharedDelete = () => {
    if (props.pendingDeleteSharedCalendars.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 공유캘린더가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // DB에서 삭제
    props.DeleteSharedCalendarLogic(props.pendingDeleteSharedCalendars);

    // 로컬 상태 초기화
    props.setPendingDeleteSharedCalendars([]);
    props.setIsSharedEditMode(false);
  };

  // 일정 삭제
  const HandleScheduleDelete = () => {
    const calEId = props.scheduleForm?.calEId;
    if (!calEId || calEId === '' || calEId === '0') {
      dispatch(
        showSnackbar({
          message: '삭제할 일정이 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // 삭제 확인 다이얼로그 열기
    props.setDeleteConfirmOpen(true);
  };

  // 일정 삭제 확인 후 실제 삭제 실행
  const HandleScheduleConfirmDelete = async () => {
    const calEId = props.scheduleForm?.calEId;
    props.setDeleteConfirmOpen(false);

    const ok = await props.DeleteScheduleLogic(calEId);
    if (ok) {
      // 폼 초기화
      ResetScheduleForm();
    }
  };

  // 일정 저장
  const HandleScheduleSave = async () => {
    // SaveScheduleLogic 호출
    // props.SaveScheduleLogic(props.scheduleForm, props.repeatSettings);
    const ok = await props.SaveScheduleLogic(
      props.scheduleForm,
      props.repeatSettings
    );
    if (!ok) return;

    // 팝업 닫기 및 폼 초기화
    props.setScheduleDetailPopupOpen(false);
    props.setScheduleForm({
      title: '',
      description: '',
      location: '',
      isPrivate: false,
      calendarId: '',
      startDate: dayjs(),
      endDate: dayjs().add(1, 'hour'),
      isAllDay: false,
      isRepeat: false,
      calReId: '',
      calEId: '',
      alarmYn: false,
      alarms: [],
    });
    props.setRepeatSettings({
      type: '',
      interval: 0,
      daysOfWeek: [],
      monthlyType: '',
      dayOfMonth: 0,
      weekOfMonth: 0,
      dayOfWeek: 0,
      monthOfYear: 0,
      endType: '',
      endDate: null,
      endCount: null, // 이 줄 추가
      calReId: '',
      calEId: '',
    });
  };

  // 시작일 기준 월별 설정 초기화
  const InitializeMonthlySettings = () => {
    const startDate = props.scheduleForm.startDate;
    const dayOfMonth = startDate.date();
    const dayOfWeek = startDate.day(); // 0=일요일, 1=월요일, ...

    // 해당 월의 몇 번째 주인지 계산
    const firstDayOfMonth = startDate.startOf('month');
    const weekOfMonth = Math.ceil(
      (startDate.date() + firstDayOfMonth.day()) / 7
    );

    props.setRepeatSettings((prev) => ({
      ...prev,
      dayOfMonth: dayOfMonth,
      dayOfWeek: dayOfWeek,
      weekOfMonth: weekOfMonth,
    }));
  };

  // 반복 설정 팝업 열기
  const HandleRepeatSettingsOpen = () => {
    InitializeMonthlySettings();
    // endType이 설정되지 않은 경우 기본값으로 'COUNT' (몇회반복) 설정
    if (!props.repeatSettings.endType || props.repeatSettings.endType === '') {
      props.setRepeatSettings((prev) => ({
        ...prev,
        endType: 'COUNT',
        endCount: prev.endCount || 30, // 기본값 10회
      }));
    }
    props.setRepeatSettingsPopupOpen(true);
  };

  // 반복 설정 저장
  const HandleRepeatSettingsSave = () => {
    props.setRepeatSettingsPopupOpen(false);
    dispatch(
      showSnackbar({
        message: '반복 설정이 저장되었습니다.',
        type: 'success',
      })
    );
  };

  // 반복 설정 취소
  const HandleRepeatSettingsCancel = () => {
    props.setRepeatSettingsPopupOpen(false);
  };

  // 요일 선택 토글
  const HandleDayOfWeekToggle = (day) => {
    props.setRepeatSettings((prev) => ({
      ...prev,
      daysOfWeek: prev.daysOfWeek.includes(day)
        ? prev.daysOfWeek.filter((d) => d !== day)
        : [...prev.daysOfWeek, day],
    }));
  };

  // 알람 추가
  const HandleAddAlarm = () => {
    const newAlarm = {
      id: Date.now(),
      minutes: 15,
      type: 'minutes', // minutes, hours, days, weeks
    };
    props.setScheduleForm((prev) => ({
      ...prev,
      alarms: [...prev.alarms, newAlarm],
    }));
  };

  // 알람 삭제
  const HandleDeleteAlarm = (alarmId) => {
    props.setScheduleForm((prev) => ({
      ...prev,
      alarms: prev.alarms.filter((alarm) => alarm.id !== alarmId),
    }));
  };

  // 알람 설정 변경
  const HandleAlarmChange = (alarmId, field, value) => {
    props.setScheduleForm((prev) => ({
      ...prev,
      alarms: prev.alarms.map((alarm) =>
        alarm.id === alarmId ? { ...alarm, [field]: value } : alarm
      ),
    }));
  };

  // 컴포넌트 내부(반복설정 팝업 렌더 위쪽 어딘가)에 헬퍼 추가
  const GenerateRepeatSummary = () => {
    const rs = props.repeatSettings;
    const start = props.scheduleForm?.startDate;
    const typeLabelMap = {
      daily: '매일',
      weekly: '매주',
      monthly: '매월',
      yearly: '매년',
    };
    const typeLabel = typeLabelMap[rs.type] || '반복';

    // 간격
    const intervalLabel =
      rs.type === 'daily'
        ? `${rs.interval}일마다`
        : rs.type === 'weekly'
          ? `${rs.interval}주마다`
          : rs.type === 'monthly'
            ? `${rs.interval}개월마다`
            : rs.type === 'yearly'
              ? `${rs.interval}년마다`
              : '';

    // 요일(주간)
    const weekDaysKor = [
      '일요일',
      '월요일',
      '화요일',
      '수요일',
      '목요일',
      '금요일',
      '토요일',
    ];
    const weeklyDays =
      rs.type === 'weekly' &&
      Array.isArray(rs.daysOfWeek) &&
      rs.daysOfWeek.length > 0
        ? ` (${rs.daysOfWeek.map((d) => weekDaysKor[d]).join(', ')})`
        : '';

    // 월간(일/요일 방식)
    let monthlyDetail = '';
    if (rs.type === 'monthly') {
      // 일수만 사용하므로 dayOfMonth 값을 사용
      const dayOfMonth = rs.dayOfMonth || (start ? start.date() : 0);
      if (dayOfMonth > 0) {
        monthlyDetail = ` (${dayOfMonth}일)`;
      }
    }

    // 종료 조건
    let endLabel = '';
    if (rs.endType === 'NEVER') {
      endLabel = ' / 종료: 무한반복';
    } else if (rs.endType === 'COUNT') {
      endLabel = ` / 종료: ${rs.endCount}회 반복`;
    } else if (rs.endType === 'UNTIL' && rs.endDate) {
      endLabel = ` / 종료: ${dayjs(rs.endDate).format('YYYY-MM-DD')}`;
    }

    return `${typeLabel} ${intervalLabel}${weeklyDays}${monthlyDetail}${endLabel}`;
  };

  // 달력 네비게이션 함수들
  const HandlePreviousPeriod = () => {
    if (props.viewMode === 'day') {
      props.setCurrentDate((prev) => prev.subtract(1, 'day'));
    } else if (props.viewMode === 'week') {
      props.setCurrentDate((prev) => prev.subtract(1, 'week'));
    } else if (props.viewMode === 'month') {
      props.setCurrentDate((prev) => prev.subtract(1, 'month'));
    }
  };

  const HandleNextPeriod = () => {
    if (props.viewMode === 'day') {
      props.setCurrentDate((prev) => prev.add(1, 'day'));
    } else if (props.viewMode === 'week') {
      props.setCurrentDate((prev) => prev.add(1, 'week'));
    } else if (props.viewMode === 'month') {
      props.setCurrentDate((prev) => prev.add(1, 'month'));
    }
  };

  const HandleToday = () => {
    props.setCurrentDate(dayjs());
  };

  // 날짜 클릭 핸들러
  const HandleDateClick = (date) => {
    ResetScheduleForm(date);
    props.setScheduleDetailPopupOpen(true);
  };

  // 월간 달력 데이터 생성
  const GenerateMonthCalendar = () => {
    const startOfMonth = props.currentDate.startOf('month');
    const endOfMonth = props.currentDate.endOf('month');
    const startOfCalendar = startOfMonth.startOf('week');
    const endOfCalendar = endOfMonth.endOf('week');

    const weeks = [];
    let currentWeek = startOfCalendar;

    while (
      currentWeek.isBefore(endOfCalendar) ||
      currentWeek.isSame(endOfCalendar, 'day')
    ) {
      const week = [];
      for (let i = 0; i < 7; i++) {
        const day = currentWeek.add(i, 'day');
        week.push({
          date: day,
          isCurrentMonth: day.isSame(props.currentDate, 'month'),
          isToday: day.isSame(dayjs(), 'day'),
          isSelected: day.isSame(props.currentDate, 'day'),
        });
      }
      weeks.push(week);
      currentWeek = currentWeek.add(1, 'week');
    }

    return weeks;
  };

  // 주간 달력 데이터 생성
  const GenerateWeekCalendar = () => {
    const startOfWeek = props.currentDate.startOf('week');
    const days = [];

    for (let i = 0; i < 7; i++) {
      const day = startOfWeek.add(i, 'day');
      days.push({
        date: day,
        isToday: day.isSame(dayjs(), 'day'),
        isSelected: day.isSame(props.currentDate, 'day'),
      });
    }

    return days;
  };

  // 일간 달력 데이터 생성
  const GenerateDayCalendar = () => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      hours.push({
        hour: i,
        time: dayjs().hour(i).minute(0).format('HH:mm'),
        isCurrentHour: i === dayjs().hour(),
      });
    }
    return hours;
  };

  //#endregion

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* 상단 버튼 영역 */}
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Grid container spacing={2} alignItems="center">
            <Grid xs={6}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Button
                  variant="contained"
                  startIcon={<EventIcon />}
                  onClick={() => {
                    // 폼 초기화
                    props.setScheduleForm({
                      title: '',
                      description: '',
                      location: '',
                      isPrivate: false,
                      calendarId: GetDefaultCalendarId(),
                      calEId: '',
                      calReId: '',
                      startDate: dayjs(),
                      endDate: dayjs().add(1, 'hour'),
                      isAllDay: false,
                      isRepeat: false,
                      alarmYn: false,
                      alarms: [],
                    });
                    // 반복설정 초기화
                    props.setRepeatSettings({
                      type: '',
                      interval: 0,
                      daysOfWeek: [],
                      monthlyType: '',
                      dayOfMonth: 0,
                      weekOfMonth: 0,
                      dayOfWeek: 0,
                      monthOfYear: 0,
                      endType: '',
                      endDate: null,
                      endCount: null,
                      calReId: '',
                      calEId: '',
                    });
                    // 팝업 오픈
                    props.setScheduleDetailPopupOpen(true);
                  }}
                >
                  일정등록
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<CalendarTodayIcon />}
                  onClick={() => {
                    props.setModalToggle2(true);
                  }}
                >
                  캘린더 환경설정
                </Button>
              </Box>
            </Grid>
            <Grid xs={6}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button
                  variant={props.viewMode === 'day' ? 'contained' : 'outlined'}
                  startIcon={<ViewDayIcon />}
                  onClick={() => props.setViewMode('day')}
                >
                  일간
                </Button>
                <Button
                  variant={props.viewMode === 'week' ? 'contained' : 'outlined'}
                  startIcon={<ViewWeekIcon />}
                  onClick={() => props.setViewMode('week')}
                >
                  주간
                </Button>
                <Button
                  variant={
                    props.viewMode === 'month' ? 'contained' : 'outlined'
                  }
                  startIcon={<ViewModuleIcon />}
                  onClick={() => props.setViewMode('month')}
                >
                  월간
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* 메인 컨텐츠 영역 */}
        <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          {/* 왼쪽 사이드바 */}
          <Box
            sx={{
              width: 300,
              borderRight: 1,
              borderColor: 'divider',
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            {/* 오늘 날짜 박스 */}
            <Card sx={{ mb: 2, flexShrink: 0 }}>
              <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarTodayIcon
                    color="primary"
                    sx={{ fontSize: '1.2rem' }}
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontSize: '0.95rem', fontWeight: 600 }}
                  >
                    {dayjs().format('YYYY년 MM월 DD일')}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: '0.8rem', mt: 0.5 }}
                >
                  {dayjs().format('dddd')}
                </Typography>
              </CardContent>
            </Card>

            {/* 내 캘린더 영역 */}
            <Card
              sx={{
                mb: 2,
                display: 'flex',
                flexDirection: 'column',
                flex: '1.5 1 0%', // ✅ 높이 조정 (2 -> 1.5로 줄임)
                minHeight: 0,
              }}
            >
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  overflow: 'hidden',
                  p: '16px !important',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    flexShrink: 0, // ✅ 고정 높이
                  }}
                >
                  <Typography variant="h6">내 캘린더</Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="새 캘린더 추가">
                      <IconButton
                        size="small"
                        onClick={() => {
                          props.setEditingCalendar(null);
                          props.setCalendarForm({
                            DESCRIPTION: '',
                            COLOR: '#6aa84f',
                            IS_PUBLIC: '0',
                            calId: '',
                          });
                          props.setCalendarPopupOpen(true);
                        }}
                        sx={{
                          width: '28px',
                          height: '28px',
                          padding: '4px',
                          '& .MuiSvgIcon-root': {
                            fontSize: '1rem',
                          },
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title={
                        props.isEditMode
                          ? '편집 모드 종료'
                          : '편집 모드로 전환하여 캘린더 삭제'
                      }
                    >
                      <Button
                        variant={props.isEditMode ? 'contained' : 'outlined'}
                        size="small"
                        startIcon={
                          <EditIcon
                            sx={{
                              fontSize: '0.75rem !important',
                            }}
                          />
                        }
                        onClick={HandleEditModeToggle}
                        sx={{
                          minWidth: 'auto !important',
                          maxWidth: 'none',
                          width: 'auto',
                          px: '0.5rem !important',
                          py: '0.25rem !important',
                          fontSize: '0.6rem !important',
                          lineHeight: '1.2 !important',
                          whiteSpace: 'nowrap',
                          height: '30px !important',
                          minHeight: '30px !important',
                          maxHeight: '30px !important',
                          backgroundColor: props.isEditMode
                            ? '#1976d2'
                            : 'transparent',
                          color: props.isEditMode ? 'white' : '#1976d2',
                          borderColor: props.isEditMode ? '#1976d2' : '#1976d2',
                          '& .MuiButton-startIcon': {
                            marginRight: '0.25rem !important',
                            marginLeft: '0 !important',
                            '& .MuiSvgIcon-root': {
                              fontSize: '0.75rem !important',
                            },
                          },
                          '& .MuiButton-text': {
                            fontSize: '0.6rem !important',
                            padding: '0.25rem 0.5rem !important',
                          },
                          '&:hover': {
                            backgroundColor: props.isEditMode
                              ? '#1565c0'
                              : '#e3f2fd',
                            borderColor: props.isEditMode
                              ? '#1565c0'
                              : '#1976d2',
                          },
                        }}
                      >
                        {props.isEditMode ? '편집 종료' : '편집'}
                      </Button>
                    </Tooltip>
                    {props.isEditMode &&
                      props.pendingDeleteCalendars.length > 0 && (
                        <>
                          <Tooltip title="삭제 취소">
                            <IconButton
                              size="small"
                              onClick={HandleCancelDelete}
                              sx={{
                                backgroundColor: '#ff9800',
                                color: 'white',
                                width: '28px',
                                height: '28px',
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: '#f57c00',
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: '1rem',
                                },
                              }}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="삭제 확인">
                            <IconButton
                              size="small"
                              onClick={HandleConfirmDelete}
                              sx={{
                                backgroundColor: '#4caf50',
                                color: 'white',
                                width: '28px',
                                height: '28px',
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: '#388e3c',
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: '1rem',
                                },
                              }}
                            >
                              <CheckIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                  </Box>
                </Box>

                {/* 삭제 대기 중인 캘린더와 캘린더 리스트를 함께 스크롤 가능하게 */}
                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  {/* 삭제 대기 중인 캘린더 표시 */}
                  {props.isEditMode &&
                    props.pendingDeleteCalendars.length > 0 && (
                      <Box
                        sx={{
                          mb: 2,
                          p: 1.5,
                          backgroundColor: '#ffebee',
                          borderRadius: 1,
                          border: '1px solid #ffcdd2',
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="error"
                          sx={{ mb: 0.5, fontSize: '0.75rem' }}
                        >
                          삭제 대기 중 ({props.pendingDeleteCalendars.length}개)
                        </Typography>
                        <List dense sx={{ py: 0 }}>
                          {props.pendingDeleteCalendars.map((calendarId) => {
                            const calendar = props.myCalendars.find(
                              (cal) => cal.calId === calendarId
                            );
                            return (
                              <ListItem
                                key={calendarId}
                                sx={{ px: 0, py: 0.25 }}
                              >
                                <Box
                                  sx={{
                                    width: 10,
                                    height: 10,
                                    backgroundColor: calendar?.color || '#ccc',
                                    borderRadius: 1,
                                    mr: 1,
                                    flexShrink: 0,
                                  }}
                                />
                                <ListItemText
                                  primary={
                                    calendar?.description || '알 수 없는 캘린더'
                                  }
                                  primaryTypographyProps={{
                                    sx: {
                                      fontSize: '0.75rem',
                                    },
                                  }}
                                  sx={{
                                    flex: 1,
                                    opacity: 0.7,
                                    textDecoration: 'line-through',
                                  }}
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      </Box>
                    )}

                  <List dense>
                    {props.myCalendars
                      .filter(
                        (calendar) =>
                          !props.pendingDeleteCalendars.includes(calendar.calId)
                      )
                      .map((calendar) => (
                        <ListItem
                          key={calendar.calId}
                          sx={{ px: 0, position: 'relative' }}
                        >
                          {props.isEditMode ? (
                            <IconButton
                              size="small"
                              onClick={() =>
                                HandleMarkForDelete(calendar.calId)
                              }
                              sx={{
                                p: 0.5,
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  color: 'white',
                                },
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          ) : (
                            <Checkbox
                              checked={calendar.checked}
                              onChange={() =>
                                HandleCalendarToggle(calendar.calId, true)
                              }
                              sx={{ p: 0.5 }}
                              inputProps={{ 'aria-hidden': true }}
                            />
                          )}

                          <ListItemText
                            primary={calendar.description}
                            sx={{ flex: 1, pr: 1 }}
                          />

                          {/* 색상 표시 */}
                          <Box
                            sx={{
                              width: 15,
                              height: 15,
                              backgroundColor: calendar.color,
                              borderRadius: 8,
                              mr: 1,
                              cursor: 'pointer',
                              border: '1px solid #ccc',
                              '&:hover': {
                                transform: 'scale(1.2)',
                              },
                            }}
                            onClick={(e) =>
                              HandleColorPickerToggle(calendar.calId, e)
                            }
                            data-color-box
                          />

                          {/* 색상 팔레트 - 클릭한 위치 기준으로 표시 (내 캘린더 팝업에서는 제외) */}
                          {props.colorPickerOpen[calendar.calId]?.isOpen &&
                            !props.modalToggle2 && (
                              <Box
                                sx={{
                                  position: 'fixed',
                                  top: props.colorPickerOpen[calendar.calId]
                                    .position.top,
                                  left: props.colorPickerOpen[calendar.calId]
                                    .position.left,
                                  zIndex: 9999,
                                  backgroundColor: 'white',
                                  border: '1px solid #ccc',
                                  borderRadius: 1,
                                  p: 1,
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(5, 1fr)',
                                  gap: 0.5,
                                  minWidth: 120,
                                }}
                                data-color-picker
                              >
                                {props.colorPalette.map((colorItem) => (
                                  <Box
                                    key={`${calendar.calId}-${colorItem.id}`}
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      backgroundColor: colorItem.color,
                                      borderRadius: 0.5,
                                      cursor: 'pointer',
                                      border: '1px solid #ccc',
                                      '&:hover': {
                                        transform: 'scale(1.1)',
                                        border: '2px solid #1976d2',
                                      },
                                    }}
                                    onClick={() =>
                                      HandleColorChange(
                                        calendar.calId,
                                        colorItem.color
                                      )
                                    }
                                    data-color-picker
                                  />
                                ))}
                              </Box>
                            )}
                        </ListItem>
                      ))}
                  </List>
                </Box>
              </CardContent>
            </Card>

            {/* 공유 캘린더 영역 */}
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: '3 1 0%',
                minHeight: 0,
              }}
            >
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  overflow: 'hidden',
                  p: '16px !important',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <Typography variant="h6">공유 캘린더</Typography>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Tooltip title="새 공유 캘린더 추가">
                      <IconButton
                        size="small"
                        onClick={() => {
                          props.setSupplierPopupOpen(true);
                          props.setSearchKeyword('');
                          props.HandleSupplierSearch();
                        }}
                        sx={{
                          width: '28px',
                          height: '28px',
                          padding: '4px',
                          '& .MuiSvgIcon-root': {
                            fontSize: '1rem',
                          },
                        }}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip
                      title={
                        props.isSharedEditMode
                          ? '편집 모드 종료'
                          : '편집 모드로 전환하여 공유 캘린더 삭제'
                      }
                    >
                      <Button
                        variant={
                          props.isSharedEditMode ? 'contained' : 'outlined'
                        }
                        size="small"
                        startIcon={
                          <EditIcon
                            sx={{
                              fontSize: '0.75rem !important',
                            }}
                          />
                        }
                        onClick={HandleSharedEditModeToggle}
                        sx={{
                          minWidth: 'auto !important',
                          maxWidth: 'none',
                          width: 'auto',
                          px: '0.5rem !important',
                          py: '0.25rem !important',
                          fontSize: '0.6rem !important',
                          lineHeight: '1.2 !important',
                          whiteSpace: 'nowrap',
                          height: '30px !important',
                          minHeight: '30px !important',
                          maxHeight: '30px !important',
                          backgroundColor: props.isSharedEditMode
                            ? '#1976d2'
                            : 'transparent',
                          color: props.isSharedEditMode ? 'white' : '#1976d2',
                          borderColor: props.isSharedEditMode
                            ? '#1976d2'
                            : '#1976d2',
                          '& .MuiButton-startIcon': {
                            marginRight: '0.25rem !important',
                            marginLeft: '0 !important',
                            '& .MuiSvgIcon-root': {
                              fontSize: '0.75rem !important',
                            },
                          },
                          '& .MuiButton-text': {
                            fontSize: '0.6rem !important',
                            padding: '0.25rem 0.5rem !important',
                          },
                          '&:hover': {
                            backgroundColor: props.isSharedEditMode
                              ? '#1565c0'
                              : '#e3f2fd',
                            borderColor: props.isSharedEditMode
                              ? '#1565c0'
                              : '#1976d2',
                          },
                        }}
                      >
                        {props.isSharedEditMode ? '편집 종료' : '편집'}
                      </Button>
                    </Tooltip>
                    {props.isSharedEditMode &&
                      props.pendingDeleteSharedCalendars.length > 0 && (
                        <>
                          <Tooltip title="삭제 취소">
                            <IconButton
                              size="small"
                              onClick={HandleCancelSharedDelete}
                              sx={{
                                backgroundColor: '#ff9800',
                                color: 'white',
                                width: '28px',
                                height: '28px',
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: '#f57c00',
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: '1rem',
                                },
                              }}
                            >
                              <RefreshIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="삭제 확인">
                            <IconButton
                              size="small"
                              onClick={HandleConfirmSharedDelete}
                              sx={{
                                backgroundColor: '#4caf50',
                                color: 'white',
                                width: '28px',
                                height: '28px',
                                padding: '4px',
                                '&:hover': {
                                  backgroundColor: '#388e3c',
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: '1rem',
                                },
                              }}
                            >
                              <CheckIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                  </Box>
                </Box>

                {/* 삭제 대기 중인 공유캘린더 표시 */}
                {props.isSharedEditMode &&
                  props.pendingDeleteSharedCalendars.length > 0 && (
                    <Box
                      sx={{
                        mb: 2,
                        p: 2,
                        backgroundColor: '#ffebee',
                        borderRadius: 1,
                        border: '1px solid #ffcdd2',
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="error"
                        sx={{ mb: 1 }}
                      >
                        삭제 대기 중 (
                        {props.pendingDeleteSharedCalendars.length}개)
                      </Typography>
                      <List dense>
                        {props.pendingDeleteSharedCalendars.map(
                          (sharedCalendar, index) => (
                            <ListItem key={index} sx={{ px: 0 }}>
                              <Box
                                sx={{
                                  width: 12,
                                  height: 12,
                                  backgroundColor:
                                    sharedCalendar.color || '#ccc',
                                  borderRadius: 1,
                                  mr: 1,
                                }}
                              />
                              <ListItemText
                                primary={
                                  sharedCalendar.name || '알 수 없는 공유캘린더'
                                }
                                sx={{
                                  flex: 1,
                                  opacity: 0.7,
                                  textDecoration: 'line-through',
                                }}
                              />
                            </ListItem>
                          )
                        )}
                      </List>
                    </Box>
                  )}

                {/* {공유캘린더 영역} */}
                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  <List dense>
                    {props.sharedCalendars
                      .filter(
                        (calendar) =>
                          !props.pendingDeleteSharedCalendars.some(
                            (pending) =>
                              pending.userId === calendar.userId &&
                              pending.calMId === calendar.calMId
                          )
                      )
                      .map((calendar) => (
                        <ListItem
                          key={calendar.calMId || calendar.id}
                          sx={{ px: 0, position: 'relative' }}
                        >
                          {props.isSharedEditMode ? (
                            <IconButton
                              size="small"
                              onClick={() =>
                                HandleMarkSharedForDelete(calendar)
                              }
                              sx={{
                                p: 0.5,
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  color: 'white',
                                },
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          ) : (
                            // 신청대기가 아닐 때만 체크박스 표시
                            calendar.isWait !== '0' &&
                            calendar.isWait !== 0 && (
                              <Checkbox
                                checked={calendar.checked}
                                onChange={() =>
                                  HandleCalendarToggle(calendar.calMId, false)
                                }
                                sx={{ p: 0.5 }}
                                inputProps={{ 'aria-hidden': true }}
                              />
                            )
                          )}

                          <ListItemText
                            primary={
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                }}
                              >
                                <Typography variant="body2" sx={{ flex: 1 }}>
                                  {calendar.calendarNm || calendar.name}
                                </Typography>
                                {calendar.isWait === '0' ||
                                calendar.isWait === 0 ? (
                                  <Chip
                                    label="신청대기"
                                    size="small"
                                    sx={{
                                      height: 20,
                                      fontSize: '0.7rem',
                                      backgroundColor: '#ff9800',
                                      color: 'white',
                                      fontWeight: 'bold',
                                    }}
                                  />
                                ) : null}
                              </Box>
                            }
                            sx={{ flex: 1, pr: 1 }}
                          />

                          {/* 색상 표시 - 신청대기가 아닐 때만 표시 */}
                          {calendar.isWait !== '0' && calendar.isWait !== 0 && (
                            <Box
                              sx={{
                                width: 15,
                                height: 15,
                                backgroundColor: calendar.color,
                                borderRadius: 5,
                                mr: 1,
                                cursor: 'pointer',
                                border: '1px solid #ccc',
                                '&:hover': {
                                  transform: 'scale(1.2)',
                                },
                              }}
                              onClick={(e) => {
                                HandleSharedColorPickerToggle(
                                  calendar.calMId || calendar.id,
                                  e
                                );
                              }}
                              data-color-box
                            />
                          )}

                          {/* 색상 선택 팔레트  공유캘린더 - 신청대기가 아닐 때만 표시 */}
                          {calendar.isWait !== '0' &&
                            calendar.isWait !== 0 &&
                            props.colorPickerOpen[
                              calendar.calMId || calendar.id
                            ]?.isOpen && (
                              <Box
                                sx={{
                                  position: 'fixed',
                                  top: props.colorPickerOpen[
                                    calendar.calMId || calendar.id
                                  ].position.top,
                                  left: props.colorPickerOpen[
                                    calendar.calMId || calendar.id
                                  ].position.left,
                                  zIndex: 9999,
                                  backgroundColor: 'white',
                                  border: '1px solid #ccc',
                                  borderRadius: 1,
                                  p: 1,
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(5, 1fr)',
                                  gap: 0.5,
                                  minWidth: 120,
                                }}
                                data-color-picker
                              >
                                {props.colorPalette.map((colorItem) => (
                                  <Box
                                    key={`${calendar.calMId || calendar.id}-${colorItem.id}`}
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      backgroundColor: colorItem.color,
                                      borderRadius: 0.5,
                                      cursor: 'pointer',
                                      border: '1px solid #ccc',
                                      '&:hover': {
                                        transform: 'scale(1.1)',
                                        border: '2px solid #1976d2',
                                      },
                                    }}
                                    onClick={() =>
                                      HandleSharedColorChange(
                                        calendar.calMId || calendar.id,
                                        colorItem.color
                                      )
                                    }
                                    data-color-picker
                                  />
                                ))}
                              </Box>
                            )}
                        </ListItem>
                      ))}
                  </List>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* 메인 달력 영역 */}
          <Box sx={{ flex: 1, p: 2, overflow: 'hidden' }}>
            <Paper sx={{ height: '100%', p: 2, overflow: 'hidden' }}>
              {/* 달력 헤더 */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                <Typography variant="h5">
                  {props.viewMode === 'day' &&
                    `${props.currentDate.format('YYYY년 MM월 DD일')} 일정`}
                  {props.viewMode === 'week' &&
                    `${props.currentDate.startOf('week').format('YYYY년 MM월 DD일')} ~ ${props.currentDate
                      .endOf('week')
                      .format('YYYY년 MM월 DD일')}`}
                  {props.viewMode === 'month' &&
                    `${props.currentDate.format('YYYY년 MM월')} 달력`}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <IconButton onClick={HandlePreviousPeriod}>
                    <ChevronLeftIcon />
                  </IconButton>
                  <Button
                    variant="outlined"
                    startIcon={<TodayIcon />}
                    onClick={HandleToday}
                    size="small"
                  >
                    오늘
                  </Button>
                  <IconButton onClick={HandleNextPeriod}>
                    <ChevronRightIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* 달력 컨텐츠 */}
              <Box sx={{ height: 'calc(100% - 80px)', overflow: 'hidden' }}>
                {props.viewMode === 'month' && (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {/* 요일 헤더 */}
                    <Box
                      sx={{
                        display: 'flex',
                        borderBottom: 2,
                        borderColor: 'primary.main',
                      }}
                    >
                      {['일', '월', '화', '수', '목', '금', '토'].map(
                        (day, index) => (
                          <Box
                            key={day}
                            sx={{
                              flex: 1,
                              p: 1.5,
                              textAlign: 'center',
                              fontWeight: 'bold',
                              backgroundColor:
                                index === 0
                                  ? '#ffebee'
                                  : index === 6
                                    ? '#e8f5e8'
                                    : '#f8f9fa',
                              color:
                                index === 0
                                  ? '#d32f2f'
                                  : index === 6
                                    ? '#2e7d32'
                                    : 'text.primary',
                              borderRight:
                                index < 6 ? '1px solid #e0e0e0' : 'none',
                            }}
                          >
                            {day}
                          </Box>
                        )
                      )}
                    </Box>

                    {/* 달력 그리드 */}
                    <Box
                      sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                    >
                      {GenerateMonthCalendar().map((week, weekIndex) => (
                        <Box
                          key={weekIndex}
                          sx={{
                            display: 'flex',
                            flex: 1,
                            borderBottom: '1px solid #e0e0e0',
                          }}
                        >
                          {week.map((day, dayIndex) => (
                            <Box
                              key={dayIndex}
                              sx={{
                                flex: 1,
                                p: 1,
                                cursor: 'pointer',
                                backgroundColor: day.isToday
                                  ? '#e3f2fd'
                                  : 'white',
                                borderRight:
                                  dayIndex < 6 ? '1px solid #e0e0e0' : 'none',
                                position: 'relative',
                                minHeight: 'calc((100vh - 200px) / 6)',
                                '&:hover': {
                                  backgroundColor: day.isToday
                                    ? '#bbdefb'
                                    : '#f5f5f5',
                                },
                              }}
                              onClick={() => HandleDateClick(day.date)}
                            >
                              {/* 날짜 표시 */}
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  mb: 1,
                                }}
                              >
                                {(() => {
                                  const isSunday = day.date.day() === 0; // 일요일 확인 (dayjs에서 0=일요일)
                                  const sundayColor = '#ff5252'; // 빨간색

                                  // 공휴일 확인
                                  const holidayName = props.getHolidayForDate
                                    ? props.getHolidayForDate(day.date)
                                    : null;
                                  const isHoliday = !!holidayName;

                                  return (
                                    <>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 0.5,
                                          flex: 1,
                                        }}
                                      >
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            color: day.isCurrentMonth
                                              ? isSunday || isHoliday
                                                ? sundayColor
                                                : 'text.primary'
                                              : 'text.secondary',
                                            fontWeight: day.isToday
                                              ? 'bold'
                                              : 'normal',
                                            fontSize: '0.9rem',
                                          }}
                                        >
                                          {day.date.format('D')}
                                        </Typography>
                                        {holidayName && (
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              color: sundayColor,
                                              fontSize: '0.65rem',
                                              fontWeight: 'medium',
                                              lineHeight: 1,
                                            }}
                                          >
                                            {holidayName}
                                          </Typography>
                                        )}
                                      </Box>
                                      {day.isToday && (
                                        <Box
                                          sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            backgroundColor: '#1976d2',
                                          }}
                                        />
                                      )}
                                    </>
                                  );
                                })()}
                              </Box>

                              {/* 일정 표시 영역 */}
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 40, // 공휴일명 표시를 위해 top을 28에서 40으로 증가
                                  left: 4,
                                  right: 4,
                                  bottom: 2,
                                  overflow: 'hidden',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 0.25,
                                }}
                              >
                                {(() => {
                                  const dayStart = day.date.startOf('day');
                                  const dayEnd = day.date.endOf('day');

                                  const eventsForDay = (
                                    props.calendarEvents || []
                                  ).filter((ev) => {
                                    if (!ev) return false;

                                    // startDt와 endDt를 우선 사용 (프로시저 반환값)
                                    // dayjs()는 이미 dayjs 객체인 경우 그대로 반환하므로 안전하게 사용 가능
                                    // 백엔드가 반환하는 필드명이 StartDt/EndDt (대문자)일 수 있으므로 모두 확인
                                    const evStart = dayjs(
                                      ev.start ||
                                        ev.startDt ||
                                        ev.StartDt ||
                                        ev.START_DT ||
                                        ev.start_DT
                                    );
                                    const evEnd = dayjs(
                                      ev.end ||
                                        ev.endDt ||
                                        ev.EndDt ||
                                        ev.END_DT ||
                                        ev.end_DT
                                    );

                                    if (!evStart.isValid() || !evEnd.isValid())
                                      return false;

                                    // 일정이 해당 날짜와 겹치는지 확인 (주간 뷰 종일 일정 필터링 로직과 동일)
                                    const overlaps =
                                      (evStart.isBefore(dayEnd) ||
                                        evStart.isSame(dayStart, 'day')) &&
                                      (evEnd.isAfter(dayStart) ||
                                        evEnd.isSame(dayEnd, 'day'));

                                    return overlaps;
                                  });

                                  const displayedEvents = eventsForDay.slice(
                                    0,
                                    4
                                  );
                                  const remainingCount =
                                    eventsForDay.length - 4;

                                  return (
                                    <>
                                      {displayedEvents.map((ev) => (
                                        <Box
                                          key={ev.id || ev.calEId || ev.calReId}
                                          sx={{
                                            flex: '0 0 auto',
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              backgroundColor:
                                                ev.color ||
                                                ev.displayColor ||
                                                '#1976d2',
                                              color: 'white',
                                              py: 0.25,
                                              px: 0.5,
                                              borderRadius: 0.5,
                                              fontSize: '0.65rem',
                                              lineHeight: 1.2,
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                              cursor: 'pointer',
                                            }}
                                            title={ev.title || ''}
                                            onClick={(e) =>
                                              HandleEventClick(ev, e)
                                            }
                                          >
                                            {ev.allDay ||
                                            ev.allDay === 'Y' ||
                                            ev.allDay === true
                                              ? `[종일] ${ev.title || ''}`
                                              : `${dayjs(ev.start || ev.startDt).format('HH:mm')} ${ev.title || ev.TITLE || ''}`}
                                          </Box>
                                        </Box>
                                      ))}
                                      {remainingCount > 0 && (
                                        <Box
                                          sx={{
                                            flex: '0 0 auto',
                                            py: 0.25,
                                            px: 0.5,
                                            borderRadius: 0.5,
                                            fontSize: '0.65rem',
                                            lineHeight: 1.2,
                                            backgroundColor: '#e3f2fd',
                                            color: '#1976d2',
                                            cursor: 'pointer',
                                            textAlign: 'center',
                                            '&:hover': {
                                              backgroundColor: '#bbdefb',
                                            },
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            props.setMoreEventsData({
                                              date: day.date,
                                              events: eventsForDay,
                                            });
                                            props.setMoreEventsPopupOpen(true);
                                          }}
                                        >
                                          +{remainingCount}개 더보기
                                        </Box>
                                      )}
                                    </>
                                  );
                                })()}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}

                {props.viewMode === 'week' && (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {/* 요일 헤더 */}
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        borderBottom: 2,
                        borderColor: 'primary.main',
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          flexShrink: 0,
                          boxSizing: 'border-box',
                          p: 1,
                          textAlign: 'center',
                          fontWeight: 'bold',
                          backgroundColor: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.75rem',
                        }}
                      >
                        시간
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flex: 1,
                          minWidth: 0,
                          maxWidth: '100%',
                          width: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        {GenerateWeekCalendar().map((day, index) => {
                          const isSunday = day.date.day() === 0; // 일요일 확인 (dayjs에서 0=일요일)
                          const weekDaysKor = [
                            '일',
                            '월',
                            '화',
                            '수',
                            '목',
                            '금',
                            '토',
                          ];
                          const dayOfWeekKor = weekDaysKor[day.date.day()];
                          const sundayColor = '#ff5252'; // 더 밝은 빨간색
                          return (
                            <Box
                              key={day.date.format('YYYY-MM-DD')}
                              sx={{
                                flex: '1 1 0%',
                                minWidth: 0,
                                maxWidth: '100%',
                                width: 0,
                                boxSizing: 'border-box',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                backgroundColor: day.isToday
                                  ? '#e3f2fd'
                                  : '#f8f9fa',
                                borderRight:
                                  index < 6 ? '1px solid #e0e0e0' : 'none',
                                color: day.isToday
                                  ? '#1976d2'
                                  : isSunday
                                    ? sundayColor
                                    : 'text.primary',
                                overflow: 'hidden',
                                position: 'relative',
                              }}
                            >
                              <Box sx={{ p: 1.5 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: isSunday ? sundayColor : 'inherit',
                                  }}
                                >
                                  {day.date.format('MM/DD')} ({dayOfWeekKor})
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>

                    {/* 종일 일정 영역 */}
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        borderBottom: '1px solid #e0e0e0',
                        minHeight: 40,
                        backgroundColor: '#fff9e6',
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          flexShrink: 0,
                          boxSizing: 'border-box',
                          p: 1,
                          textAlign: 'center',
                          fontWeight: 'bold',
                          fontSize: '0.75rem',
                          backgroundColor: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        종일일정
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flex: 1,
                          minWidth: 0,
                          maxWidth: '100%',
                          width: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        {GenerateWeekCalendar().map((day, dayIndex) => {
                          const allDayEvents = (
                            props.calendarEvents || []
                          ).filter((ev) => {
                            if (!ev) return false;

                            const evStart = dayjs(ev.start || ev.startDt);
                            const evEnd = dayjs(ev.end || ev.endDt);
                            if (!evStart.isValid() || !evEnd.isValid())
                              return false;

                            // 종일 일정 판단:
                            // 1. allDay 플래그가 있으면 종일
                            // 2. 시작일과 종료일이 같은 날짜이고, 모두 00:00:00이면 종일
                            // 3. 시작일과 종료일이 같은 날짜이고, 종료일이 23:59:59이면 종일
                            const hasAllDayFlag =
                              ev.allDay ||
                              ev.allDay === true ||
                              ev.allDay === 'Y';

                            const isSameDay = evStart.isSame(evEnd, 'day');
                            const startIsMidnight =
                              evStart.hour() === 0 &&
                              evStart.minute() === 0 &&
                              evStart.second() === 0;
                            const endIsMidnight =
                              evEnd.hour() === 0 &&
                              evEnd.minute() === 0 &&
                              evEnd.second() === 0;
                            const endIsEndOfDay =
                              evEnd.hour() === 23 &&
                              evEnd.minute() === 59 &&
                              evEnd.second() === 59;

                            const isAllDay =
                              hasAllDayFlag ||
                              (isSameDay &&
                                startIsMidnight &&
                                (endIsMidnight || endIsEndOfDay));

                            if (!isAllDay) return false;

                            const dayStart = day.date.startOf('day');
                            const dayEnd = day.date.endOf('day');

                            return (
                              (evStart.isBefore(dayEnd) ||
                                evStart.isSame(dayStart, 'day')) &&
                              (evEnd.isAfter(dayStart) ||
                                evEnd.isSame(dayEnd, 'day'))
                            );
                          });

                          // 공휴일 확인
                          const holidayName = props.getHolidayForDate
                            ? props.getHolidayForDate(day.date)
                            : null;

                          return (
                            <Box
                              key={day.date.format('YYYY-MM-DD')}
                              sx={{
                                flex: '1 1 0%',
                                minWidth: 0,
                                maxWidth: '100%',
                                width: 0,
                                boxSizing: 'border-box',
                                borderRight:
                                  dayIndex < 6 ? '1px solid #e0e0e0' : 'none',
                                overflow: 'hidden',
                                position: 'relative',
                              }}
                            >
                              <Box
                                sx={{
                                  p: 0.5,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 0.5,
                                  height: '100%',
                                }}
                              >
                                {/* 공휴일 표시 */}
                                {holidayName && (
                                  <Box
                                    sx={{
                                      backgroundColor: '#ff5252',
                                      color: 'white',
                                      borderRadius: 0.5,
                                      p: 0.5,
                                      fontSize: '0.7rem',
                                      fontWeight: 'medium',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {holidayName}
                                  </Box>
                                )}
                                {/* 종일 일정 표시 */}
                                {allDayEvents.map((ev) => (
                                  <Box
                                    key={ev.id || ev.calEId || ev.calReId}
                                    sx={{
                                      backgroundColor:
                                        ev.color || ev.COLOR || '#1976d2',
                                      color: 'white',
                                      borderRadius: 0.5,
                                      p: 0.5,
                                      fontSize: '0.7rem',
                                      cursor: 'pointer',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                    title={ev.title || ''}
                                    onClick={(e) => HandleEventClick(ev, e)}
                                  >
                                    {ev.title || ''}
                                  </Box>
                                ))}
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>

                    {/* 타임라인 그리드 */}
                    <Box
                      sx={{
                        flex: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        position: 'relative',
                        boxSizing: 'border-box',
                        width: '100%',
                        maxWidth: '100%',
                      }}
                    >
                      {/* 주간 일정 시간 범위 계산 */}
                      {(() => {
                        // 주간의 모든 시간 기반 일정에서 최소/최대 시간 찾기
                        const weekStart = props.currentDate.startOf('week');
                        const weekEnd = props.currentDate.endOf('week');

                        const timeEvents = (props.calendarEvents || []).filter(
                          (ev) => {
                            if (!ev) return false;
                            const isAllDay =
                              ev.allDay ||
                              ev.allDay === true ||
                              ev.allDay === 'Y';
                            if (isAllDay) return false;

                            const evStart = dayjs(ev.start || ev.startDt);
                            const evEnd = dayjs(ev.end || ev.endDt);
                            if (!evStart.isValid() || !evEnd.isValid())
                              return false;

                            return (
                              (evStart.isAfter(weekStart) ||
                                evStart.isSame(weekStart, 'day')) &&
                              (evEnd.isBefore(weekEnd) ||
                                evEnd.isSame(weekEnd, 'day'))
                            );
                          }
                        );

                        let minHour = 24;
                        let maxHour = -1;

                        timeEvents.forEach((ev) => {
                          const evStart = dayjs(ev.start || ev.startDt);
                          const evEnd = dayjs(ev.end || ev.endDt);

                          if (!evStart.isValid() || !evEnd.isValid()) return;

                          // 일정이 주간 범위와 겹치는지 확인
                          const overlapsWeek =
                            (evStart.isBefore(weekEnd) ||
                              evStart.isSame(weekEnd, 'day')) &&
                            (evEnd.isAfter(weekStart) ||
                              evEnd.isSame(weekStart, 'day'));

                          if (overlapsWeek) {
                            // 일정의 원래 시작/종료 시간 추출 (한 번만)
                            let originalStartHour, originalEndHour;

                            if (ev.startDt && typeof ev.startDt === 'string') {
                              const startMatch = ev.startDt.match(
                                /(\d{2}):(\d{2}):(\d{2})/
                              );
                              originalStartHour = startMatch
                                ? parseInt(startMatch[1], 10)
                                : evStart.hour();
                            } else {
                              originalStartHour = evStart.hour();
                            }

                            if (ev.endDt && typeof ev.endDt === 'string') {
                              const endMatch = ev.endDt.match(
                                /(\d{2}):(\d{2}):(\d{2})/
                              );
                              originalEndHour = endMatch
                                ? parseInt(endMatch[1], 10)
                                : evEnd.hour();
                            } else {
                              originalEndHour = evEnd.hour();
                            }

                            // 주간 범위 내의 각 날짜에서 일정이 표시되는 시간 고려
                            // 일정이 여러 날에 걸쳐 있을 수 있으므로, 각 날짜의 시간을 확인
                            for (
                              let d = weekStart;
                              d.isBefore(weekEnd) || d.isSame(weekEnd, 'day');
                              d = d.add(1, 'day')
                            ) {
                              const dayStart = d.startOf('day');
                              const dayEnd = d.endOf('day');

                              // 해당 날짜에 일정이 걸쳐있는지 확인
                              const dayOverlaps =
                                (evStart.isBefore(dayEnd) ||
                                  evStart.isSame(dayEnd, 'day')) &&
                                (evEnd.isAfter(dayStart) ||
                                  evEnd.isSame(dayStart, 'day'));

                              if (dayOverlaps) {
                                let dayStartHour, dayEndHour;

                                if (evStart.isSame(dayStart, 'day')) {
                                  // 시작 날짜: 실제 시작 시간
                                  dayStartHour = evStart.hour();
                                } else {
                                  // 중간 날짜: 원래 시작 시간
                                  dayStartHour = originalStartHour;
                                }

                                if (evEnd.isSame(dayEnd, 'day')) {
                                  // 끝 날짜: 실제 종료 시간
                                  dayEndHour = evEnd.hour();
                                } else {
                                  // 중간 날짜: 원래 종료 시간
                                  dayEndHour = originalEndHour;
                                }

                                minHour = Math.min(
                                  minHour,
                                  dayStartHour,
                                  dayEndHour
                                );
                                maxHour = Math.max(
                                  maxHour,
                                  dayStartHour,
                                  dayEndHour
                                );
                              }
                            }
                          }
                        });

                        // 항상 0시~23시 전체 표시
                        const startHour = 0;
                        const endHour = 23;
                        const hourRange = endHour - startHour + 1;

                        return (
                          <Box
                            sx={{
                              display: 'flex',
                              width: '100%',
                              boxSizing: 'border-box',
                            }}
                          >
                            {/* 시간 라벨 영역 */}
                            <Box
                              sx={{
                                width: 80,
                                flexShrink: 0,
                                boxSizing: 'border-box',
                              }}
                            >
                              {Array.from({ length: hourRange }, (_, i) => {
                                const hour = startHour + i;
                                const hourHeight = `calc((100vh - 300px) / ${hourRange})`;
                                return (
                                  <Box
                                    key={hour}
                                    sx={{
                                      height: hourHeight,
                                      boxSizing: 'border-box',
                                      p: 1,
                                      textAlign: 'center',
                                      backgroundColor: '#f8f9fa',
                                      display: 'flex',
                                      alignItems: 'flex-start',
                                      justifyContent: 'center',
                                      fontWeight: 'bold',
                                      fontSize: '0.75rem',
                                      borderBottom: '1px solid #e0e0e0',
                                      color:
                                        hour === dayjs().hour()
                                          ? '#1976d2'
                                          : 'text.secondary',
                                    }}
                                  >
                                    {hour.toString().padStart(2, '0')}
                                  </Box>
                                );
                              })}
                            </Box>

                            {/* 각 요일별 일정 영역 */}
                            <Box
                              sx={{
                                display: 'flex',
                                flex: 1,
                                minWidth: 0,
                                maxWidth: '100%',
                                width: '100%',
                                boxSizing: 'border-box',
                              }}
                            >
                              {GenerateWeekCalendar().map((day, dayIndex) => {
                                // 해당 날짜의 시간 기반 일정 필터링
                                const dayEvents = (
                                  props.calendarEvents || []
                                ).filter((ev) => {
                                  if (!ev) return false;
                                  const isAllDay =
                                    ev.allDay ||
                                    ev.allDay === true ||
                                    ev.allDay === 'Y';
                                  if (isAllDay) return false;

                                  const evStart = dayjs(ev.start || ev.startDt);
                                  const evEnd = dayjs(ev.end || ev.endDt);
                                  if (!evStart.isValid() || !evEnd.isValid())
                                    return false;

                                  const dayStart = day.date.startOf('day');
                                  const dayEnd = day.date.endOf('day');

                                  return (
                                    evStart.isSame(dayStart, 'day') ||
                                    (evStart.isBefore(dayEnd) &&
                                      evEnd.isAfter(dayStart))
                                  );
                                });

                                // 겹치는 일정 처리: 각 일정의 시간 정보를 먼저 계산
                                const eventsWithTime = dayEvents
                                  .map((ev) => {
                                    const evStart = ev.start
                                      ? dayjs(ev.start)
                                      : dayjs(ev.startDt);
                                    const evEnd = ev.end
                                      ? dayjs(ev.end)
                                      : dayjs(ev.endDt);

                                    if (!evStart.isValid() || !evEnd.isValid())
                                      return null;

                                    // 일정의 원래 시작/종료 시간 추출 (한 번만)
                                    let originalStartHour,
                                      originalStartMinute,
                                      originalEndHour,
                                      originalEndMinute;

                                    if (
                                      ev.startDt &&
                                      typeof ev.startDt === 'string'
                                    ) {
                                      const startMatch = ev.startDt.match(
                                        /(\d{2}):(\d{2}):(\d{2})/
                                      );
                                      if (startMatch) {
                                        originalStartHour = parseInt(
                                          startMatch[1],
                                          10
                                        );
                                        originalStartMinute = parseInt(
                                          startMatch[2],
                                          10
                                        );
                                      } else {
                                        originalStartHour = evStart.hour();
                                        originalStartMinute = evStart.minute();
                                      }
                                    } else {
                                      originalStartHour = evStart.hour();
                                      originalStartMinute = evStart.minute();
                                    }

                                    if (
                                      ev.endDt &&
                                      typeof ev.endDt === 'string'
                                    ) {
                                      const endMatch = ev.endDt.match(
                                        /(\d{2}):(\d{2}):(\d{2})/
                                      );
                                      if (endMatch) {
                                        originalEndHour = parseInt(
                                          endMatch[1],
                                          10
                                        );
                                        originalEndMinute = parseInt(
                                          endMatch[2],
                                          10
                                        );
                                      } else {
                                        originalEndHour = evEnd.hour();
                                        originalEndMinute = evEnd.minute();
                                      }
                                    } else {
                                      originalEndHour = evEnd.hour();
                                      originalEndMinute = evEnd.minute();
                                    }

                                    // 시간 설정: 모든 날짜에 원래 시작/종료 시간 사용
                                    let startHour,
                                      startMinute,
                                      endHour,
                                      endMinute;

                                    // 모든 날짜에 원래 시작 시간 사용
                                    startHour = originalStartHour;
                                    startMinute = originalStartMinute;

                                    // 끝 날짜면 원래 종료 시간 사용, 아니면 원래 종료 시간 사용
                                    endHour = originalEndHour;
                                    endMinute = originalEndMinute;

                                    const startMinutes =
                                      startHour * 60 + startMinute;
                                    const endMinutes = endHour * 60 + endMinute;

                                    return {
                                      event: ev,
                                      evStart,
                                      evEnd,
                                      startHour,
                                      startMinute,
                                      endHour,
                                      endMinute,
                                      startMinutes,
                                      endMinutes,
                                    };
                                  })
                                  .filter((item) => item !== null);

                                // 겹치는 일정 그룹 찾기
                                const overlapGroups = [];
                                const processed = new Set();

                                eventsWithTime.forEach((item1, index1) => {
                                  if (processed.has(index1)) return;

                                  const group = [item1];
                                  processed.add(index1);

                                  eventsWithTime.forEach((item2, index2) => {
                                    if (
                                      index1 === index2 ||
                                      processed.has(index2)
                                    )
                                      return;

                                    // 두 일정이 겹치는지 확인
                                    const overlaps =
                                      item1.startMinutes < item2.endMinutes &&
                                      item2.startMinutes < item1.endMinutes;

                                    if (overlaps) {
                                      group.push(item2);
                                      processed.add(index2);
                                    }
                                  });

                                  overlapGroups.push(group);
                                });

                                return (
                                  <Box
                                    key={day.date.format('YYYY-MM-DD')}
                                    sx={{
                                      flex: '1 1 0%',
                                      minWidth: 0,
                                      maxWidth: '100%',
                                      width: 0,
                                      boxSizing: 'border-box',
                                      position: 'relative',
                                      borderRight:
                                        dayIndex < 6
                                          ? '1px solid #e0e0e0'
                                          : 'none',
                                      backgroundColor: day.isToday
                                        ? '#f5f5f5'
                                        : 'white',
                                      minHeight: '100%',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    {/* 시간 슬롯 배경 */}
                                    {Array.from(
                                      { length: hourRange },
                                      (_, i) => {
                                        const hour = startHour + i;
                                        const hourHeight = `calc((100vh - 300px) / ${hourRange})`;
                                        return (
                                          <Box
                                            key={hour}
                                            sx={{
                                              height: hourHeight,
                                              borderBottom: '1px solid #e0e0e0',
                                              cursor: 'pointer',
                                              '&:hover': {
                                                backgroundColor: '#f5f5f5',
                                              },
                                            }}
                                            onClick={() =>
                                              HandleDateClick(
                                                day.date.hour(hour).minute(0)
                                              )
                                            }
                                          />
                                        );
                                      }
                                    )}

                                    {/* 일정 블록 배치 - 겹침 처리 적용 */}
                                    {overlapGroups.flatMap((group) => {
                                      return group.map((item, groupIndex) => {
                                        const {
                                          event: ev,
                                          startMinutes,
                                          endMinutes,
                                        } = item;

                                        // 시간을 분으로 변환
                                        const durationMinutes =
                                          endMinutes - startMinutes;

                                        // 동적으로 계산된 시작 시간 기준으로 top 계산 (분 단위)
                                        const baseHour = startHour;
                                        const topMinutes =
                                          startMinutes - baseHour * 60;

                                        // 전체 높이 계산 (동적 범위)
                                        const totalVisibleMinutes =
                                          hourRange * 60;

                                        // top과 height 계산
                                        const topPercent =
                                          (topMinutes / totalVisibleMinutes) *
                                          100;
                                        const heightPercent =
                                          (durationMinutes /
                                            totalVisibleMinutes) *
                                          100;

                                        // 최소 높이 보장 (30분 이상)
                                        const minHeightMinutes = 30;
                                        const actualHeightPercent =
                                          durationMinutes < minHeightMinutes
                                            ? (minHeightMinutes /
                                                totalVisibleMinutes) *
                                              100
                                            : heightPercent;

                                        // 겹치는 일정 배치: 그룹 내에서 가로로 분할
                                        const groupSize = group.length;
                                        const eventIndex = groupIndex; // 그룹 내 인덱스 (0부터 시작)
                                        const gapPercent = 2; // 일정 간 간격 (퍼센트)
                                        const totalGap =
                                          (groupSize - 1) * gapPercent; // 전체 간격
                                        const availableWidth = 100 - totalGap; // 사용 가능한 전체 너비
                                        const widthPercent =
                                          availableWidth / groupSize; // 각 일정의 너비 (퍼센트)
                                        const leftPercent =
                                          eventIndex *
                                          (widthPercent + gapPercent); // 왼쪽 위치 (퍼센트)

                                        // 툴팁 내용 생성 (제목과 시간만)
                                        const startDate = dayjs(
                                          ev.start || ev.startDt
                                        );
                                        const endDate = dayjs(
                                          ev.end || ev.endDt
                                        );
                                        const startDateStr =
                                          startDate.format('YYYY-MM-DD');
                                        const endDateStr =
                                          endDate.format('YYYY-MM-DD');
                                        const startTimeStr =
                                          startDate.format('HH:mm');
                                        const endTimeStr =
                                          endDate.format('HH:mm');

                                        const dateRange =
                                          startDateStr === endDateStr
                                            ? startDateStr
                                            : `${startDateStr}~${endDateStr}`;
                                        const timeRange = `${startTimeStr}~${endTimeStr}`;

                                        const tooltipContent = (
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontWeight: 'bold',
                                                mb: 0.5,
                                              }}
                                            >
                                              {ev.title || ''}
                                            </Typography>
                                            <Typography
                                              variant="caption"
                                              sx={{ display: 'block' }}
                                            >
                                              {dateRange} {timeRange}
                                            </Typography>
                                          </Box>
                                        );

                                        return (
                                          <Tooltip
                                            key={
                                              ev.id || ev.calEId || ev.calReId
                                            }
                                            title={tooltipContent}
                                            arrow
                                            placement="top"
                                          >
                                            <Box
                                              sx={{
                                                position: 'absolute',
                                                top: `${topPercent}%`,
                                                // 겹치는 일정 배치: left와 width를 계산하여 가로로 분할
                                                // 부모 Box의 전체 넓이를 기준으로 정확히 계산
                                                left: `${leftPercent}%`,
                                                width: `${widthPercent}%`,
                                                boxSizing: 'border-box',
                                                height: `${actualHeightPercent}%`,
                                                minHeight: 40,
                                                backgroundColor:
                                                  ev.color ||
                                                  ev.COLOR ||
                                                  '#1976d2',
                                                color: 'white',
                                                borderRadius: 1,
                                                p: 0.75,
                                                cursor: 'pointer',
                                                boxShadow:
                                                  '0 1px 3px rgba(0,0,0,0.12)',
                                                zIndex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-start',
                                                overflow: 'hidden',
                                                '&:hover': {
                                                  boxShadow:
                                                    '0 2px 6px rgba(0,0,0,0.2)',
                                                  zIndex: 2,
                                                },
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                HandleEventClick(ev, e);
                                              }}
                                            >
                                              {/* 첫 줄: 시간 */}
                                              <Typography
                                                variant="caption"
                                                sx={{
                                                  fontWeight: 'bold',
                                                  fontSize: '0.7rem',
                                                  mb: 0.25,
                                                  whiteSpace: 'nowrap',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                }}
                                              >
                                                {dayjs(
                                                  ev.start || ev.startDt
                                                ).format('HH:mm')}
                                              </Typography>
                                              {/* 두 번째 줄: 제목 */}
                                              <Typography
                                                variant="caption"
                                                sx={{
                                                  fontWeight: 'bold',
                                                  fontSize: '0.7rem',
                                                  whiteSpace: 'nowrap',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                }}
                                              >
                                                {ev.title || ''}
                                              </Typography>
                                            </Box>
                                          </Tooltip>
                                        );
                                      });
                                    })}
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        );
                      })()}
                    </Box>
                  </Box>
                )}

                {props.viewMode === 'day' && (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {/* 헤더 */}
                    <Box
                      sx={{
                        display: 'flex',
                        borderBottom: 2,
                        borderColor: 'primary.main',
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          p: 1.5,
                          textAlign: 'center',
                          fontWeight: 'bold',
                          backgroundColor: '#f8f9fa',
                        }}
                      >
                        시간
                      </Box>
                      <Box
                        sx={{
                          flex: 1,
                          p: 1.5,
                          textAlign: 'center',
                          fontWeight: 'bold',
                          backgroundColor: '#e3f2fd',
                          color:
                            props.currentDate.day() === 0
                              ? '#ff5252'
                              : '#1976d2',
                        }}
                      >
                        {props.currentDate.format('MM/DD')} (
                        {
                          ['일', '월', '화', '수', '목', '금', '토'][
                            props.currentDate.day()
                          ]
                        }
                        )
                      </Box>
                    </Box>

                    {/* 종일 일정 영역 */}
                    <Box
                      sx={{
                        display: 'flex',
                        borderBottom: '2px solid #e0e0e0',
                        minHeight: 40,
                        backgroundColor: '#fff9e6',
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          p: 1,
                          textAlign: 'center',
                          fontWeight: 'bold',
                          fontSize: '0.75rem',
                          backgroundColor: '#f8f9fa',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        종일일정
                      </Box>
                      <Box
                        sx={{
                          flex: 1,
                          p: 0.5,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 0.5,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {(() => {
                          // 해당 날짜의 종일 일정 필터링
                          const allDayEvents = (
                            props.calendarEvents || []
                          ).filter((ev) => {
                            if (!ev) return false;

                            const evStart = dayjs(ev.start || ev.startDt);
                            const evEnd = dayjs(ev.end || ev.endDt);

                            if (!evStart.isValid() || !evEnd.isValid()) {
                              return false;
                            }

                            // 종일 일정 판단:
                            // 1. allDay 플래그가 있으면 종일
                            // 2. 시작일과 종료일이 같은 날짜이고, 모두 00:00:00이면 종일
                            // 3. 시작일과 종료일이 같은 날짜이고, 종료일이 23:59:59이면 종일
                            const hasAllDayFlag =
                              ev.allDay ||
                              ev.allDay === true ||
                              ev.allDay === 'Y';

                            const isSameDay = evStart.isSame(evEnd, 'day');
                            const startIsMidnight =
                              evStart.hour() === 0 &&
                              evStart.minute() === 0 &&
                              evStart.second() === 0;
                            const endIsMidnight =
                              evEnd.hour() === 0 &&
                              evEnd.minute() === 0 &&
                              evEnd.second() === 0;
                            const endIsEndOfDay =
                              evEnd.hour() === 23 &&
                              evEnd.minute() === 59 &&
                              evEnd.second() === 59;

                            const isAllDay =
                              hasAllDayFlag ||
                              (isSameDay &&
                                startIsMidnight &&
                                (endIsMidnight || endIsEndOfDay));

                            if (!isAllDay) return false;

                            // 주간 뷰와 동일하게 dayjs 객체로 비교
                            // 종일 일정이 해당 날짜와 겹치는지 확인
                            // 종일 일정의 경우 시작일과 종료일이 모두 00:00:00이거나,
                            // 시작일이 00:00:00이고 종료일이 23:59:59인 경우
                            // 해당 날짜와 같은 날짜인지만 확인하면 됨
                            const evStartDay = evStart.startOf('day');
                            const evEndDay = evEnd.startOf('day');
                            const currentDay = props.currentDate.startOf('day');

                            // 시작일이나 종료일 중 하나라도 현재 날짜와 같으면 표시
                            return (
                              evStartDay.isSame(currentDay, 'day') ||
                              evEndDay.isSame(currentDay, 'day') ||
                              (evStartDay.isBefore(currentDay) &&
                                evEndDay.isAfter(currentDay))
                            );
                          });

                          // 공휴일 확인
                          const holidayName = props.getHolidayForDate
                            ? props.getHolidayForDate(props.currentDate)
                            : null;

                          return (
                            <>
                              {/* 공휴일 표시 */}
                              {holidayName && (
                                <Box
                                  sx={{
                                    backgroundColor: '#ff5252',
                                    color: 'white',
                                    borderRadius: 0.5,
                                    p: 0.5,
                                    fontSize: '0.7rem',
                                    fontWeight: 'medium',
                                    textAlign: 'center',
                                  }}
                                >
                                  {holidayName}
                                </Box>
                              )}
                              {/* 종일 일정 표시 */}
                              {allDayEvents.map((ev) => (
                                <Box
                                  key={ev.id || ev.calEId || ev.calReId}
                                  sx={{
                                    backgroundColor: ev.color || '#1976d2',
                                    color: 'white',
                                    borderRadius: 0.5,
                                    p: 0.5,
                                    fontSize: '0.7rem',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                  title={ev.title || ''}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    HandleEventClick(ev, e);
                                  }}
                                >
                                  {ev.title || ev.TITLE || ''}
                                </Box>
                              ))}
                            </>
                          );
                        })()}
                      </Box>
                    </Box>

                    {/* 타임라인 */}
                    <Box
                      sx={{ flex: 1, overflow: 'auto', position: 'relative' }}
                    >
                      {/* 시간 슬롯 배경 */}
                      {GenerateDayCalendar().map((hourData) => (
                        <Box
                          key={hourData.hour}
                          sx={{
                            display: 'flex',
                            borderBottom: '1px solid #e0e0e0',
                            height: 'calc((100vh - 200px) / 24)',
                          }}
                        >
                          {/* 시간 표시 */}
                          <Box
                            sx={{
                              width: 80,
                              p: 1,
                              textAlign: 'center',
                              backgroundColor: '#f8f9fa',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold',
                              fontSize: '0.8rem',
                              color: hourData.isCurrentHour
                                ? '#1976d2'
                                : 'text.secondary',
                            }}
                          >
                            {hourData.time}
                          </Box>

                          {/* 일정 영역 */}
                          <Box
                            sx={{
                              flex: 1,
                              cursor: 'pointer',
                              backgroundColor: hourData.isCurrentHour
                                ? '#e3f2fd'
                                : 'white',
                              position: 'relative',
                              minHeight: '100%',
                              overflow: 'hidden',
                              border: '1px solid transparent',
                              '&:hover': {
                                backgroundColor: '#f5f5f5',
                                border: '1px solid #1976d2',
                              },
                            }}
                            onClick={() =>
                              HandleDateClick(
                                props.currentDate.hour(hourData.hour)
                              )
                            }
                          />
                        </Box>
                      ))}

                      {/* 일간: 시간 기반 일정 표시 (주간 뷰와 동일한 방식) */}
                      {(() => {
                        // 해당 날짜의 시간 기반 일정 필터링
                        const dayEvents = (props.calendarEvents || []).filter(
                          (ev) => {
                            if (!ev) return false;
                            const isAllDay =
                              ev.allDay ||
                              ev.allDay === true ||
                              ev.allDay === 'Y';
                            if (isAllDay) return false;

                            const evStart = dayjs(ev.start || ev.startDt);
                            const evEnd = dayjs(ev.end || ev.endDt);
                            if (!evStart.isValid() || !evEnd.isValid())
                              return false;

                            const dayStart = props.currentDate.startOf('day');
                            const dayEnd = props.currentDate.endOf('day');

                            return (
                              evStart.isSame(dayStart, 'day') ||
                              (evStart.isBefore(dayEnd) &&
                                evEnd.isAfter(dayStart))
                            );
                          }
                        );

                        // 겹치는 일정 처리: 각 일정의 시간 정보를 먼저 계산
                        const eventsWithTime = dayEvents
                          .map((ev) => {
                            const evStart = ev.start
                              ? dayjs(ev.start)
                              : dayjs(ev.startDt);
                            const evEnd = ev.end
                              ? dayjs(ev.end)
                              : dayjs(ev.endDt);

                            if (!evStart.isValid() || !evEnd.isValid())
                              return null;

                            // 일정의 원래 시작/종료 시간 추출 (한 번만)
                            let originalStartHour,
                              originalStartMinute,
                              originalEndHour,
                              originalEndMinute;

                            if (ev.startDt && typeof ev.startDt === 'string') {
                              const startMatch = ev.startDt.match(
                                /(\d{2}):(\d{2}):(\d{2})/
                              );
                              if (startMatch) {
                                originalStartHour = parseInt(startMatch[1], 10);
                                originalStartMinute = parseInt(
                                  startMatch[2],
                                  10
                                );
                              } else {
                                originalStartHour = evStart.hour();
                                originalStartMinute = evStart.minute();
                              }
                            } else {
                              originalStartHour = evStart.hour();
                              originalStartMinute = evStart.minute();
                            }

                            if (ev.endDt && typeof ev.endDt === 'string') {
                              const endMatch = ev.endDt.match(
                                /(\d{2}):(\d{2}):(\d{2})/
                              );
                              if (endMatch) {
                                originalEndHour = parseInt(endMatch[1], 10);
                                originalEndMinute = parseInt(endMatch[2], 10);
                              } else {
                                originalEndHour = evEnd.hour();
                                originalEndMinute = evEnd.minute();
                              }
                            } else {
                              originalEndHour = evEnd.hour();
                              originalEndMinute = evEnd.minute();
                            }

                            // 시간 설정: 모든 날짜에 원래 시작/종료 시간 사용
                            let startHour, startMinute, endHour, endMinute;

                            // 모든 날짜에 원래 시작 시간 사용
                            startHour = originalStartHour;
                            startMinute = originalStartMinute;

                            // 모든 날짜에 원래 종료 시간 사용
                            endHour = originalEndHour;
                            endMinute = originalEndMinute;

                            const startMinutes = startHour * 60 + startMinute;
                            const endMinutes = endHour * 60 + endMinute;

                            return {
                              event: ev,
                              evStart,
                              evEnd,
                              startHour,
                              startMinute,
                              endHour,
                              endMinute,
                              startMinutes,
                              endMinutes,
                            };
                          })
                          .filter((item) => item !== null);

                        // 겹치는 일정 그룹 찾기
                        const overlapGroups = [];
                        const processed = new Set();

                        eventsWithTime.forEach((item1, index1) => {
                          if (processed.has(index1)) return;

                          const group = [item1];
                          processed.add(index1);

                          eventsWithTime.forEach((item2, index2) => {
                            if (index1 === index2 || processed.has(index2))
                              return;

                            // 두 일정이 겹치는지 확인
                            const overlaps =
                              item1.startMinutes < item2.endMinutes &&
                              item2.startMinutes < item1.endMinutes;

                            if (overlaps) {
                              group.push(item2);
                              processed.add(index2);
                            }
                          });

                          overlapGroups.push(group);
                        });

                        // 각 그룹에서 일정 배치
                        return overlapGroups.flatMap((group) => {
                          return group.map((item, groupIndex) => {
                            const {
                              event: ev,
                              startHour,
                              startMinute,
                              startMinutes,
                              endMinutes,
                            } = item;

                            // 시간을 분으로 변환
                            const durationMinutes = endMinutes - startMinutes;

                            // 각 시간 슬롯의 높이는 calc((100vh - 200px) / 24)
                            const slotIndex = startHour; // 0~23
                            const minutesInSlot = startMinute; // 0~59

                            // 겹치는 일정 배치: 그룹 내에서 가로로 분할
                            const groupSize = group.length;
                            const eventIndex = groupIndex; // 그룹 내 인덱스 (0부터 시작)
                            const gapPercent = 1; // 일정 간 간격 (퍼센트)
                            const availableWidth =
                              100 - (groupSize - 1) * gapPercent; // 사용 가능한 전체 너비
                            const widthPercent = availableWidth / groupSize; // 각 일정의 너비 (퍼센트)
                            const leftPercent =
                              eventIndex * (widthPercent + gapPercent); // 왼쪽 위치 (퍼센트)

                            // 최소 높이 보장 (30분 이상)
                            const minHeightMinutes = 30;
                            const actualHeightMinutes =
                              durationMinutes < minHeightMinutes
                                ? minHeightMinutes
                                : durationMinutes;

                            // 툴팁 내용 생성 (제목과 시간만)
                            const startDate = dayjs(ev.start || ev.startDt);
                            const endDate = dayjs(ev.end || ev.endDt);
                            const startDateStr = startDate.format('YYYY-MM-DD');
                            const endDateStr = endDate.format('YYYY-MM-DD');
                            const startTimeStr = startDate.format('HH:mm');
                            const endTimeStr = endDate.format('HH:mm');

                            const dateRange =
                              startDateStr === endDateStr
                                ? startDateStr
                                : `${startDateStr}~${endDateStr}`;
                            const timeRange = `${startTimeStr}~${endTimeStr}`;

                            const tooltipContent = (
                              <Box>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 'bold', mb: 0.5 }}
                                >
                                  {ev.title || ev.TITLE || ''}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ display: 'block' }}
                                >
                                  {dateRange} {timeRange}
                                </Typography>
                              </Box>
                            );

                            return (
                              <Tooltip
                                key={ev.id || ev.calEId || ev.calReId}
                                title={tooltipContent}
                                arrow
                                placement="top"
                              >
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    // calc()를 사용하여 각 슬롯의 실제 위치 계산
                                    top: `calc((100vh - 200px) / 24 * ${slotIndex} + (100vh - 200px) / 24 / 60 * ${minutesInSlot})`,
                                    // 겹치는 일정 배치: left와 width를 계산하여 가로로 분할
                                    // 일정 영역은 left: 82px부터 시작하므로, 실제 너비는 (100% - 84px)
                                    left: `calc(82px + (100% - 84px) * ${leftPercent} / 100)`,
                                    width: `calc((100% - 84px) * ${widthPercent} / 100)`,
                                    // 높이도 calc()로 계산: durationMinutes를 분 단위로 변환 (최소 30분)
                                    height: `calc((100vh - 200px) / 24 / 60 * ${actualHeightMinutes})`,
                                    minHeight: 40,
                                    backgroundColor: ev.color || '#1976d2',
                                    color: 'white',
                                    borderRadius: 1,
                                    p: 0.75,
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                                    zIndex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                    overflow: 'hidden',
                                    '&:hover': {
                                      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                      zIndex: 2,
                                    },
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    HandleEventClick(ev, e);
                                  }}
                                >
                                  {/* 첫 줄: 시간 */}
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 'bold',
                                      fontSize: '0.7rem',
                                      mb: 0.25,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {dayjs(ev.start || ev.startDt).format(
                                      'HH:mm'
                                    )}
                                  </Typography>
                                  {/* 두 번째 줄: 제목 */}
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 'bold',
                                      fontSize: '0.7rem',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {ev.title || ''}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            );
                          });
                        });
                      })()}
                    </Box>
                  </Box>
                )}
              </Box>
            </Paper>
          </Box>
        </Box>

        {/* 캘린더 추가 팝업 */}
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.calendarPopupOpen}
          onClose={() => props.setCalendarPopupOpen(false)}
          maxWidth="xs"
          fullWidth={false}
          contentSx={{
            p: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
            },
          }}
          saveButtonName="확인"
          closeButtonName="취소"
          useSaveButton={true}
          useCloseButton={false}
          onSave={HandleCalendarSave}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                bgcolor: '#f6f7f8',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <AddIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    캘린더 추가
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => props.setCalendarPopupOpen(false)}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box sx={{ p: 2, minWidth: 280 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <TextField
                    fullWidth
                    label="캘린더명"
                    value={props.calendarForm.description}
                    onChange={(e) =>
                      props.setCalendarForm((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e5e7eb',
                        },
                        '&:hover fieldset': {
                          borderColor: '#d1d5db',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'primary.main',
                        },
                      },
                    }}
                  />
                </Paper>
              </Box>
            </Box>
          }
        />

        {/* 공유자 선택 팝업 */}
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.supplierPopupOpen}
          onClose={() => {
            props.setSupplierPopupOpen(false);
            props.setSelectedSuppliers([]);
          }}
          maxWidth={false}
          fullWidth={false}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
            },
          }}
          sx={{
            '& .MuiDialog-paper': {
              width: '800px',
              maxWidth: '800px',
            },
          }}
          saveButtonName="저장"
          closeButtonName="취소"
          useSaveButton={true}
          useCloseButton={false}
          onSave={props.HandleSupplierSelection}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                  zIndex: 20,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <PersonAddIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    공유자 선택
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => {
                    props.setSupplierPopupOpen(false);
                    props.setSelectedSuppliers([]);
                  }}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box sx={{ display: 'flex', flex: 1, gap: 2, p: 2, overflow: 'hidden' }}>
                {/* 중간: 검색 결과 리스트 */}
                <Paper
                  elevation={0}
                  sx={{
                    flex: 2,
                    p: 2,
                    minWidth: 0,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <TextField
                      placeholder="이름 또는 ID로 검색"
                      variant="outlined"
                      size="small"
                      sx={{ flex: 1 }}
                      value={props.searchKeyword || ''}
                      onChange={(e) => props.setSearchKeyword?.(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          props.HandleSupplierSearch();
                        }
                      }}
                    />
                    <Button
                      variant="contained"
                      onClick={props.HandleSupplierSearch}
                      sx={{
                        minWidth: '80px',
                        bgcolor: '#1976d2',
                        '&:hover': {
                          bgcolor: '#1565c0',
                        },
                      }}
                    >
                      검색
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        // 전체 선택
                        const allSuppliers = props.supplierGridData || [];
                        props.setSelectedSuppliers([...allSuppliers]);
                      }}
                      sx={{
                        minWidth: '80px',
                        borderColor: '#e0e0e0',
                        color: '#5f6368',
                        '&:hover': {
                          borderColor: '#1976d2',
                          bgcolor: 'rgba(25, 118, 210, 0.04)',
                        },
                      }}
                    >
                      전체선택
                    </Button>
                  </Box>
                <div
                  className="ag-theme-alpine"
                  style={{ height: '450px', width: '100%' }}
                >
                  <BusinessGridCommon
                    addYn1={'N'}
                    deleteYn1={'N'}
                    refreshYn1={'N'}
                    rowSelection={'multiple'}
                    columnDefs={[
                      {
                        field: 'userId',
                        headerName: 'ID',
                        width: 120,
                        minWidth: 100,
                        maxWidth: 150,
                      },
                      {
                        field: 'name',
                        headerName: '이름',
                        flex: 1,
                        minWidth: 150,
                      },
                    ]}
                    rowData={props.supplierGridData || []}
                    onCellClicked={(params) => {
                      const isSelected =
                        props.selectedSuppliers?.some(
                          (item) => item.userId === params.data.userId
                        ) || false;
                      if (isSelected) {
                        props.setSelectedSuppliers(
                          (props.selectedSuppliers || []).filter(
                            (item) => item.userId !== params.data.userId
                          )
                        );
                      } else {
                        props.setSelectedSuppliers([
                          ...(props.selectedSuppliers || []),
                          params.data,
                        ]);
                      }
                    }}
                    defaultColDef={{
                      minWidth: 80,
                      resizable: true,
                      sortable: true,
                    }}
                  />
                  </div>
                </Paper>

                {/* 오른쪽: 선택된 항목 리스트 */}
                <Paper
                  elevation={0}
                  sx={{
                    width: '280px',
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                      pb: 2,
                      borderBottom: '1px solid #f0f2f4',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        color: '#111418',
                        fontSize: '1rem',
                      }}
                    >
                      선택된 공유자 ({(props.selectedSuppliers || []).length}명)
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        props.setSelectedSuppliers([]);
                      }}
                      disabled={(props.selectedSuppliers || []).length === 0}
                      sx={{
                        borderColor: '#e0e0e0',
                        color: '#5f6368',
                        '&:hover': {
                          borderColor: '#d32f2f',
                          color: '#d32f2f',
                          bgcolor: 'rgba(211, 47, 47, 0.04)',
                        },
                      }}
                    >
                      전체삭제
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      overflow: 'auto',
                      bgcolor: '#f6f7f8',
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    {(props.selectedSuppliers || []).map((item, index) => (
                      <Paper
                        key={item.userId || index}
                        elevation={0}
                        sx={{
                          p: 1.5,
                          mb: 1,
                          bgcolor: 'white',
                          border: '1px solid #e0e0e0',
                          borderRadius: 1,
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <AccountCircleIcon
                          sx={{
                            fontSize: 32,
                            color: '#1976d2',
                            mr: 1.5,
                          }}
                        />
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: '#111418' }}
                          >
                            {item.name || item.NAME || '이름 없음'}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: '#5f6368' }}
                          >
                            ID: {item.userId || 'ID 없음'}
                          </Typography>
                        </Box>
                        <IconButton
                          size="small"
                          onClick={() => {
                            props.setSelectedSuppliers(
                              (props.selectedSuppliers || []).filter(
                                (_, i) => i !== index
                              )
                            );
                          }}
                          sx={{
                            color: '#5f6368',
                            '&:hover': {
                              color: '#d32f2f',
                              bgcolor: 'rgba(211, 47, 47, 0.04)',
                            },
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Paper>
                    ))}
                    {(props.selectedSuppliers || []).length === 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          textAlign: 'center',
                          py: 4,
                        }}
                      >
                        <PersonAddIcon
                          sx={{
                            fontSize: 48,
                            color: '#9aa0a6',
                            mb: 2,
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{ color: '#5f6368', mb: 1 }}
                        >
                          선택한 공유자가 없어요
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: '#9aa0a6' }}
                        >
                          선택된 항목을 여기에서 확인하실 수 있어요
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Box>
            </Box>
          }
        />

        {/* 일정 상세 등록 팝업 */}
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.scheduleDetailPopupOpen}
          onClose={() => {
            ResetScheduleForm();
            props.setScheduleDetailPopupOpen(false);
          }}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            height: '85vh',
            maxHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
              height: '85vh',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
            },
          }}
          sx={{
            '& .MuiDialog-paper': {
              height: '90vh',
              maxHeight: '90vh',
            },
          }}
          maxWidth="md"
          fullWidth
          saveButtonName="저장"
          closeButtonName={
            props.scheduleForm?.calEId &&
            props.scheduleForm.calEId !== '' &&
            props.scheduleForm.calEId !== '0' &&
            props.scheduleForm?.isEventOwner === false
              ? '닫기'
              : '취소'
          }
          useSaveButton={
            !props.scheduleForm?.calEId ||
            props.scheduleForm.calEId === '' ||
            props.scheduleForm.calEId === 0 ||
            props.scheduleForm?.isEventOwner !== false
          }
          useCloseButton={false}
          onSave={HandleScheduleSave}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxHeight: '90vh',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                mt: 0,
                pt: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                  zIndex: 20,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <EventIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    일정 등록
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {props.scheduleForm?.calEId &&
                  props.scheduleForm.calEId !== '' &&
                  props.scheduleForm.calEId !== '0' &&
                  props.scheduleForm?.isEventOwner !== false ? (
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<DeleteIcon />}
                      onClick={HandleScheduleDelete}
                      sx={{
                        borderColor: '#e0e0e0',
                        color: '#5f6368',
                        '&:hover': {
                          borderColor: '#d32f2f',
                          color: '#d32f2f',
                          bgcolor: 'rgba(211, 47, 47, 0.04)',
                        },
                      }}
                    >
                      삭제
                    </Button>
                  ) : null}
                  <IconButton
                    onClick={() => {
                      ResetScheduleForm();
                      props.setScheduleDetailPopupOpen(false);
                    }}
                    sx={{
                      color: '#5f6368',
                      '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Paper>

              {/* Main Content - Scrollable */}
              <Box
                sx={{
                  flex: 1,
                  p: 2,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  minHeight: 0,
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Grid container spacing={2}>
                {/* 수정/삭제 분기 제거: 저장 로직만 사용 */}
                {/* 작성자가 아닌 경우 입력 필드 비활성화 */}
                {(() => {
                  const isReadOnly =
                    props.scheduleForm?.calEId &&
                    props.scheduleForm.calEId !== '' &&
                    props.scheduleForm.calEId !== 0 &&
                    props.scheduleForm?.isEventOwner === false
                      ? true
                      : false;
                  return (
                    <>
                      {/* 일정 제목과 비공개 체크박스 */}
                      <Grid xs={12}>
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
                        >
                          <TextField
                            fullWidth
                            label="일정 제목"
                            value={props.scheduleForm.title}
                            onChange={(e) =>
                              props.setScheduleForm((prev) => ({
                                ...prev,
                                title: e.target.value,
                              }))
                            }
                            required
                            disabled={isReadOnly}
                            sx={{ flex: 1, minWidth: 0 }} // flex: 1로 남은 공간 차지, устWidth: 0으로 줄바꿈 방지
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={props.scheduleForm.isPrivate}
                                onChange={(e) =>
                                  props.setScheduleForm((prev) => ({
                                    ...prev,
                                    isPrivate: e.target.checked,
                                  }))
                                }
                                disabled={isReadOnly}
                                size="small"
                              />
                            }
                            label="비공개"
                            sx={{
                              '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                              },
                            }}
                          />
                        </Box>
                      </Grid>

                      {/* 시작 날짜와 시간 */}
                      <Grid xs={3}>
                        <DatePicker
                          label="시작 날짜"
                          value={props.scheduleForm.startDate}
                          onChange={(newValue) =>
                            props.setScheduleForm((prev) => ({
                              ...prev,
                              startDate: newValue,
                            }))
                          }
                          format="YYYY/MM/DD"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              disabled: isReadOnly,
                            },
                          }}
                          disabled={isReadOnly}
                        />
                      </Grid>

                      {/* 시작 시간 (종일이 아닐 때만 표시) */}
                      {!props.scheduleForm.isAllDay && (
                        <Grid xs={3}>
                          <TimePicker
                            label="시작 시간"
                            value={props.scheduleForm.startDate}
                            onChange={(newValue) =>
                              props.setScheduleForm((prev) => ({
                                ...prev,
                                startDate: newValue,
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                disabled: isReadOnly,
                              },
                            }}
                            disabled={isReadOnly}
                          />
                        </Grid>
                      )}

                      {/* 종료 날짜 (항상 표시) */}
                      <Grid xs={3}>
                        <DatePicker
                          label="종료 날짜"
                          value={props.scheduleForm.endDate}
                          onChange={(newValue) =>
                            props.setScheduleForm((prev) => ({
                              ...prev,
                              endDate: newValue,
                            }))
                          }
                          format="YYYY/MM/DD"
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              disabled: isReadOnly,
                            },
                          }}
                          disabled={isReadOnly}
                        />
                      </Grid>

                      {/* 종료 시간 (종일이 아닐 때만 표시) */}
                      {!props.scheduleForm.isAllDay && (
                        <Grid xs={3}>
                          <TimePicker
                            label="종료 시간"
                            value={props.scheduleForm.endDate}
                            onChange={(newValue) =>
                              props.setScheduleForm((prev) => ({
                                ...prev,
                                endDate: newValue,
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                disabled: isReadOnly,
                              },
                            }}
                            disabled={isReadOnly}
                          />
                        </Grid>
                      )}

                      {/* 내 캘린더 리스트 콤보박스 - 작성자인 경우에만 표시 */}
                      {!isReadOnly && (
                        <Grid xs={12}>
                          <FormControl fullWidth>
                            <InputLabel>내 캘린더</InputLabel>
                            <Select
                              value={props.scheduleForm.calendarId ?? ''}
                              onChange={(e) =>
                                props.setScheduleForm((prev) => ({
                                  ...prev,
                                  calendarId: e.target.value,
                                }))
                              }
                            >
                              {props.myCalendars.map((calendar) => (
                                <MenuItem
                                  key={calendar.calId}
                                  value={String(calendar.calId ?? '')}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 12,
                                        height: 12,
                                        backgroundColor: calendar.color,
                                        borderRadius: 1,
                                        mr: 1,
                                      }}
                                    />
                                    {calendar.description}
                                  </Box>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )}

                      {/* 종일 체크박스 */}
                      <Grid xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={props.scheduleForm.isAllDay}
                              onChange={(e) => {
                                const isAllDay = e.target.checked;
                                props.setScheduleForm((prev) => {
                                  const startDate = dayjs(
                                    prev.startDate
                                  ).startOf('day');
                                  return {
                                    ...prev,
                                    isAllDay: isAllDay,
                                    // 종일일 경우 시작일과 종료일을 모두 같은 날짜의 00:00:00으로 설정
                                    startDate: startDate,
                                    endDate: startDate,
                                  };
                                });
                              }}
                              disabled={isReadOnly}
                            />
                          }
                          label="종일"
                        />
                      </Grid>

                      {/* 반복 체크박스 */}
                      <Grid xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                props.scheduleForm.isRepeat ||
                                (props.repeatSettings?.endType &&
                                  props.repeatSettings.endType !== 'NEVER')
                                  ? true
                                  : false
                              }
                              onChange={(e) =>
                                props.setScheduleForm((prev) => ({
                                  ...prev,
                                  isRepeat: e.target.checked,
                                }))
                              }
                              disabled={isReadOnly}
                            />
                          }
                          label="반복"
                        />
                      </Grid>

                      {/* 반복 설정 버튼 */}
                      {props.scheduleForm.isRepeat && (
                        <Grid xs={12}>
                          <Button
                            variant="outlined"
                            startIcon={<RepeatIcon />}
                            onClick={HandleRepeatSettingsOpen}
                            fullWidth
                            disabled={isReadOnly}
                          >
                            반복 설정
                          </Button>
                          {/* 현재 반복 요약 + X 아이콘으로 제거 */}
                          {(() => {
                            const hasSummary = !!GenerateRepeatSummary?.();
                            if (!hasSummary) return null;
                            return (
                              <Box
                                sx={{
                                  mt: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  p: 1,
                                  border: '1px solid #e0e0e0',
                                  borderRadius: 1,
                                  backgroundColor: '#fafafa',
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    반복
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 700 }}
                                  >
                                    {GenerateRepeatSummary()}
                                  </Typography>
                                </Box>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    props.setScheduleForm((prev) => ({
                                      ...prev,
                                      isRepeat: false,
                                    }));
                                    props.setRepeatSettings?.({
                                      type: '',
                                      interval: 0,
                                      daysOfWeek: [],
                                      monthlyType: '',
                                      dayOfMonth: 0,
                                      weekOfMonth: 0,
                                      dayOfWeek: 0,
                                      monthOfYear: 0,
                                      endType: '',
                                      endDate: null,
                                      endCount: null,
                                    });
                                  }}
                                  sx={{ ml: 1 }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            );
                          })()}
                        </Grid>
                      )}

                      {/* 알람 설정 */}
                      <Grid xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={props.scheduleForm.alarmYn || false}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                props.setScheduleForm((prev) => ({
                                  ...prev,
                                  alarmYn: checked,
                                  alarms: checked
                                    ? prev.alarms && prev.alarms.length > 0
                                      ? prev.alarms
                                      : []
                                    : [],
                                }));
                              }}
                              disabled={isReadOnly}
                            />
                          }
                          label="알람 설정"
                          sx={{ mb: 1 }}
                        />

                        {/* 알람 설정 체크박스가 체크되었을 때만 시간/단위 표시 */}
                        {props.scheduleForm.alarmYn && (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                              mb: 2,
                              mt: 1,
                            }}
                          >
                            {(() => {
                              const alarm = props.scheduleForm.alarms?.[0];
                              if (!alarm) {
                                return (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={HandleAddAlarm}
                                    disabled={isReadOnly}
                                  >
                                    알람 추가
                                  </Button>
                                );
                              }
                              return (
                                <>
                                  <TextField
                                    size="small"
                                    type="number"
                                    label="시간"
                                    value={alarm.minutes || ''}
                                    onChange={(e) =>
                                      props.setScheduleForm((prev) => ({
                                        ...prev,
                                        alarms: [
                                          {
                                            ...alarm,
                                            minutes:
                                              parseInt(e.target.value) || 0,
                                          },
                                        ],
                                      }))
                                    }
                                    disabled={isReadOnly}
                                    sx={{ width: 100 }}
                                  />
                                  <FormControl
                                    size="small"
                                    sx={{ minWidth: 120 }}
                                  >
                                    <InputLabel>단위</InputLabel>
                                    <Select
                                      value={alarm.type || 'minutes'}
                                      onChange={(e) =>
                                        props.setScheduleForm((prev) => ({
                                          ...prev,
                                          alarms: [
                                            { ...alarm, type: e.target.value },
                                          ],
                                        }))
                                      }
                                      disabled={isReadOnly}
                                    >
                                      <MenuItem value="minutes">분전</MenuItem>
                                      <MenuItem value="hours">시간전</MenuItem>
                                      <MenuItem value="days">일전</MenuItem>
                                      <MenuItem value="weeks">주전</MenuItem>
                                    </Select>
                                  </FormControl>
                                </>
                              );
                            })()}
                          </Box>
                        )}
                      </Grid>

                      {/* 장소 */}
                      <Grid xs={12}>
                        <TextField
                          fullWidth
                          label="장소"
                          value={props.scheduleForm.location}
                          onChange={(e) =>
                            props.setScheduleForm((prev) => ({
                              ...prev,
                              location: e.target.value,
                            }))
                          }
                          disabled={isReadOnly}
                          InputProps={{
                            startAdornment: (
                              <LocationOnIcon
                                sx={{ mr: 1, color: 'text.secondary' }}
                              />
                            ),
                          }}
                        />
                      </Grid>

                      {/* 내용 */}
                      <Grid xs={12}>
                        <TextField
                          fullWidth
                          label="내용"
                          multiline
                          rows={4}
                          value={props.scheduleForm.description}
                          onChange={(e) =>
                            props.setScheduleForm((prev) => ({
                              ...prev,
                              description: e.target.value,
                            }))
                          }
                          disabled={isReadOnly}
                        />
                      </Grid>
                    </>
                  );
                })()}
                  </Grid>
                </Paper>
              </Box>
            </Box>
          }
        />

        {/* 반복 설정 팝업 */}
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.repeatSettingsPopupOpen}
          onClose={HandleRepeatSettingsCancel}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
            },
          }}
          maxWidth="sm"
          fullWidth
          saveButtonName="확인"
          closeButtonName="취소"
          useSaveButton={true}
          useCloseButton={false}
          onSave={HandleRepeatSettingsSave}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                  zIndex: 20,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <RepeatIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    반복 설정
                  </Typography>
                </Box>
                <IconButton
                  onClick={HandleRepeatSettingsCancel}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box
                sx={{
                  flex: 1,
                  p: 2,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  minHeight: 0,
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                  }}
                >
                  <Grid container spacing={2}>
                {/* 반복 유형 */}
                <Grid xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>반복 유형</InputLabel>
                    <Select
                      value={props.repeatSettings.type}
                      onChange={(e) => {
                        const newType = e.target.value;
                        props.setRepeatSettings((prev) => ({
                          ...prev,
                          type: newType,
                          // 반복 유형 선택 시 간격을 자동으로 1로 설정
                          interval: prev.interval || 1,
                        }));
                      }}
                    >
                      <MenuItem value="daily">매일</MenuItem>
                      <MenuItem value="weekly">매주</MenuItem>
                      <MenuItem value="monthly">매월</MenuItem>
                      <MenuItem value="yearly">매년</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* 반복 간격 */}
                <Grid xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>
                      {props.repeatSettings.type === 'daily' && '일'}
                      {props.repeatSettings.type === 'weekly' && '주'}
                      {props.repeatSettings.type === 'monthly' && '월'}
                      {props.repeatSettings.type === 'yearly' && '년'}
                    </InputLabel>
                    <Select
                      value={props.repeatSettings.interval}
                      onChange={(e) =>
                        props.setRepeatSettings((prev) => ({
                          ...prev,
                          interval: e.target.value,
                        }))
                      }
                    >
                      {Array.from({ length: 30 }, (_, i) => i + 1).map(
                        (num) => (
                          <MenuItem key={num} value={num}>
                            {num}
                            {props.repeatSettings.type === 'daily' && '일마다'}
                            {props.repeatSettings.type === 'weekly' && '주마다'}
                            {props.repeatSettings.type === 'monthly' &&
                              '월마다'}
                            {props.repeatSettings.type === 'yearly' && '년마다'}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                {/* 시작일 표시 */}
                <Grid xs={6}>
                  <TextField
                    fullWidth
                    label="시작일"
                    value={props.scheduleForm.startDate.format('YYYY-MM-DD')}
                    disabled
                  />
                </Grid>

                {/* 매주 선택 시 요일 선택 */}
                {props.repeatSettings.type === 'weekly' && (
                  <Grid xs={12}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      요일 선택
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {['일', '월', '화', '수', '목', '금', '토'].map(
                        (day, index) => (
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox
                                checked={props.repeatSettings.daysOfWeek.includes(
                                  index
                                )}
                                onChange={() => HandleDayOfWeekToggle(index)}
                              />
                            }
                            label={day}
                          />
                        )
                      )}
                    </Box>
                  </Grid>
                )}

                {/* 매월 선택 시 일자 선택 */}
                {props.repeatSettings.type === 'monthly' && (
                  <Grid xs={12}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      반복 일자
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: 'text.secondary' }}
                    >
                      매월{' '}
                      {props.repeatSettings.dayOfMonth ||
                        props.scheduleForm.startDate.date()}
                      일
                    </Typography>
                    <TextField
                      type="number"
                      fullWidth
                      label="일자"
                      value={
                        props.repeatSettings.dayOfMonth ||
                        props.scheduleForm.startDate.date()
                      }
                      onChange={(e) => {
                        const dayValue = parseInt(e.target.value) || 1;
                        const dayOfMonth = Math.max(1, Math.min(31, dayValue)); // 1~31 사이로 제한
                        props.setRepeatSettings((prev) => ({
                          ...prev,
                          dayOfMonth: dayOfMonth,
                          monthlyType: 'day', // 일수만 사용하므로 'day'로 고정
                        }));
                      }}
                      inputProps={{ min: 1, max: 31 }}
                      helperText="1~31일 사이의 일자를 입력하세요"
                    />
                  </Grid>
                )}
                {/* 반복 종료 설정 (각 줄 분리 배치) */}
                <Grid xs={12}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    반복 종료
                  </Typography>

                  {/* 1) 반복종료 (달력) */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          checked={props.repeatSettings.endType === 'UNTIL'}
                          onChange={() =>
                            props.setRepeatSettings((prev) => ({
                              ...prev,
                              endType: 'UNTIL',
                              endDate: null,
                              endCount: 0, // 빈 문자열 대신 null로 리셋
                            }))
                          }
                        />
                      }
                      label="반복종료"
                    />
                    <TextField
                      label="종료일"
                      type="date"
                      value={
                        props.repeatSettings.endDate
                          ? dayjs(props.repeatSettings.endDate).format(
                              'YYYY-MM-DD'
                            )
                          : null
                      }
                      onChange={(e) =>
                        props.setRepeatSettings((prev) => ({
                          ...prev,
                          endDate: e.target.value
                            ? dayjs(e.target.value).toDate()
                            : null,
                        }))
                      }
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 150 }}
                      disabled={props.repeatSettings.endType !== 'UNTIL'}
                    />
                  </Box>

                  {/* 2) 몇회반복 (숫자 입력) */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          checked={props.repeatSettings.endType === 'COUNT'}
                          onChange={() =>
                            props.setRepeatSettings((prev) => ({
                              ...prev,
                              endType: 'COUNT',
                              endDate: null,
                              endCount: 0,
                            }))
                          }
                        />
                      }
                      label="몇회반복"
                    />
                    <TextField
                      label="반복 횟수"
                      type="number"
                      value={props.repeatSettings.endCount || ''}
                      onChange={(e) =>
                        props.setRepeatSettings((prev) => ({
                          ...prev,
                          endCount: e.target.value
                            ? parseInt(e.target.value, 10)
                            : 0,
                        }))
                      }
                      inputProps={{ min: 1 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            회 반복
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: '30%' }}
                      disabled={props.repeatSettings.endType !== 'COUNT'}
                    />
                  </Box>

                  {/* 3) 무한반복 */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={props.repeatSettings.endType === 'NEVER'}
                          onChange={() =>
                            props.setRepeatSettings((prev) => ({
                              ...prev,
                              endType: 'NEVER',
                              endDate: null, // 빈 문자열 대신 null로 리셋
                              endCount: 0,
                            }))
                          }
                        />
                      }
                      label="무한반복"
                    />
                  </Box>
                </Grid>
                {/* 설정 요약 */}
                <Grid xs={12}>
                  <Box
                    sx={{
                      p: 2,
                      backgroundColor: '#f6f7f8',
                      borderRadius: 1,
                      border: '1px solid #e5e7eb',
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: '#111418' }}
                    >
                      설정 요약
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#5f6368' }}>
                      반복 : {GenerateRepeatSummary()}
                    </Typography>
                  </Box>
                </Grid>
                  </Grid>
                </Paper>
              </Box>
            </Box>
          }
        />

        {/* 삭제 확인 다이얼로그 */}
        <Dialog
          open={props.deleteConfirmOpen}
          onClose={() => props.setDeleteConfirmOpen(false)}
          title="일정 삭제 확인"
          contentText="일정을 삭제하시겠습니까?"
          saveButtonName="삭제"
          closeButtonName="취소"
          useSaveButton={true}
          useCloseButton={true}
          onSave={HandleScheduleConfirmDelete}
          maxWidth="xs"
        />

        {/* 일정 더보기 팝업 */}
        <Dialog
          title={`${props.moreEventsData.date ? props.moreEventsData.date.format('MM월 DD일') : ''} 일정 ${
            props.moreEventsData.events &&
            props.moreEventsData.events.length > 0
              ? `(${props.moreEventsData.events.length}개)`
              : ''
          }`}
          open={props.moreEventsPopupOpen}
          onClose={() => props.setMoreEventsPopupOpen(false)}
          maxWidth={false}
          sx={{
            '& .MuiDialog-paper': {
              width: 280,
              maxWidth: 280,
              maxHeight: '90vh',
              height: 'auto',
              m: 1,
            },
          }}
          closeButtonName="닫기"
          useSaveButton={false}
          content={
            <Box
              sx={{
                p: 1,
              }}
            >
              <List dense sx={{ py: 0 }}>
                {props.moreEventsData.events &&
                props.moreEventsData.events.length > 0 ? (
                  props.moreEventsData.events.map((ev) => (
                    <ListItem
                      key={ev.id}
                      dense
                      sx={{
                        mb: 0.5,
                        border: '1px solid #e0e0e0',
                        borderRadius: 0.5,
                        cursor: 'pointer',
                        py: 0.5,
                        px: 1,
                        display: 'flex',
                        alignItems: 'center',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                        },
                      }}
                      onClick={(e) => {
                        HandleEventClick(ev, e);
                        props.setMoreEventsPopupOpen(false);
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            backgroundColor: ev.color || '#1976d2',
                            color: 'white',
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            mb: 0.5,
                          }}
                        >
                          <Typography
                            variant="body2"
                            fontWeight="medium"
                            sx={{ fontSize: '0.875rem' }}
                          >
                            {ev.title || ''}
                          </Typography>
                        </Box>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontSize: '0.75rem', ml: 0.5 }}
                        >
                          {ev.allDay || ev.allDay === 'Y' || ev.allDay === true
                            ? '종일'
                            : `${dayjs(ev.start || ev.startDt).format('HH:mm')} - ${dayjs(ev.end || ev.endDt).format('HH:mm')}`}
                        </Typography>
                      </Box>
                    </ListItem>
                  ))
                ) : (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ p: 1, textAlign: 'center', display: 'block' }}
                  >
                    일정이 없습니다.
                  </Typography>
                )}
              </List>
            </Box>
          }
        />

        {/* 캘린더 환경설정 팝업 */}
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.modalToggle2 || false}
          onClose={() => {
            props.setModalToggle2(false);
            props.setCalendarManagementTab(0);
            props.setFavoriteCalendarView('myFavorites');
            props.setSelectedCalendarManagementRows([]);
            // 편집 상태 초기화
            setEditingCalendarId(null);
            setEditingDescriptions({});
          }}
          onEnter={() => {
            // 팝업이 열릴 때 데이터 조회
            if (props.calendarManagementTab === 0) {
              // 내 캘린더 탭일 때는 내 캘린더 데이터 재조회
              props.SearchCalendarLogic?.();
            } else if (props.calendarManagementTab === 1) {
              // 공유 캘린더 탭일 때는 공유 캘린더 데이터 조회
              props.SearchCalendarManagementData?.(
                props.favoriteCalendarView || 'myFavorites'
              );
            }
            // 편집 상태 초기화
            setEditingCalendarId(null);
            setEditingDescriptions({});
          }}
          maxWidth="md"
          fullWidth
          closeButtonName="닫기"
          useSaveButton={false}
          useCloseButton={false}
          sx={{
            '& .MuiDialog-paper': {
              height: '900px',
              maxHeight: '900px',
            },
          }}
          contentSx={{
            p: '0 !important',
            pt: '0 !important',
            pb: '0 !important',
            px: '0 !important',
            py: '0 !important',
            m: '0 !important',
            mt: '0 !important',
            overflow: 'hidden',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
              paddingTop: '0 !important',
            },
          }}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: '#f6f7f8',
                p: 0,
                m: 0,
                overflow: 'hidden',
              }}
            >
              {/* Top Navigation Bar */}
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #f0f2f4',
                  bgcolor: 'white',
                  px: 3,
                  py: 1.5,
                  flexShrink: 0,
                  zIndex: 20,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    color: '#111418',
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(19, 127, 236, 0.1)',
                      color: 'primary.main',
                      borderRadius: 1.5,
                    }}
                  >
                    <CalendarTodayIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#111418',
                      fontSize: 18,
                      fontWeight: 'bold',
                      letterSpacing: -0.15,
                    }}
                  >
                    내 캘린더 관리
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => {
                    props.setModalToggle2(false);
                    props.setCalendarManagementTab(0);
                    props.setFavoriteCalendarView('myFavorites');
                    props.setSelectedCalendarManagementRows([]);
                    setEditingCalendarId(null);
                    setEditingDescriptions({});
                  }}
                  sx={{
                    color: '#5f6368',
                    '&:hover': {
                      bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Paper>

              {/* Main Content */}
              <Box
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  overflow: 'hidden',
                }}
              >
                <Tabs
                value={props.calendarManagementTab || 0}
                onChange={(e, newValue) => {
                  props.setCalendarManagementTab(newValue);
                  props.setSelectedCalendarManagementRows([]);
                  // 관심 캘린더 탭으로 변경 시 데이터 조회
                  if (newValue === 1) {
                    props.SearchCalendarManagementData?.(
                      props.favoriteCalendarView || 'myFavorites'
                    );
                  }
                }}
                sx={{ mb: 2 }}
              >
                <Tab label="내 캘린더" />
                <Tab label="공유 캘린더" />
              </Tabs>

              {/* 내 캘린더 탭 */}
              {props.calendarManagementTab === 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                  }}
                >
                  {/* 설명 영역 - Card로 감싸기 */}
                  <Card
                    sx={{
                      mb: 2,
                      p: 1,
                      backgroundColor: '#ffffff',
                      borderRadius: 2,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      border: '1px solid #e8e8e8',
                      flexShrink: 0,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 1,
                        flexWrap: 'nowrap',
                        width: '100%',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.75,
                          flex: '1 1 auto',
                          minWidth: 0,
                          maxWidth: 'calc(100% - 200px)',
                        }}
                      >
                        <CalendarTodayIcon
                          sx={{
                            color: '#1976d2',
                            fontSize: '1rem',
                            flexShrink: 0,
                          }}
                        />
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            fontWeight: 500,
                            fontSize: '0.75rem',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            lineHeight: 1.2,
                          }}
                        >
                          내가 생성한 캘린더 목록입니다.
                        </Typography>
                      </Box>
                      {/* 추가 버튼 및 편집 모드 토글 버튼 */}
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 0.5,
                          alignItems: 'center',
                          flexShrink: 0,
                          flexWrap: 'nowrap',
                        }}
                      >
                        {/* 캘린더 추가 버튼 */}
                        <Tooltip title="새 캘린더 추가">
                          <IconButton
                            size="small"
                            onClick={() => {
                              props.setEditingCalendar(null);
                              props.setCalendarForm({
                                description: '',
                                color: '#6aa84f',
                                isPublic: '0',
                                calId: '',
                              });
                              props.setCalendarPopupOpen(true);
                            }}
                            sx={{
                              backgroundColor: '#4caf50',
                              color: 'white',
                              width: '36px',
                              height: '36px',
                              padding: '6px',
                              '&:hover': {
                                backgroundColor: '#388e3c',
                              },
                              '& .MuiSvgIcon-root': {
                                fontSize: '1.25rem',
                              },
                            }}
                          >
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                        {/* 편집 모드 토글 버튼 */}
                        <Tooltip
                          title={
                            props.isEditMode
                              ? '편집 모드 종료'
                              : '편집 모드로 전환하여 캘린더 삭제'
                          }
                        >
                          <Button
                            variant={
                              props.isEditMode ? 'contained' : 'outlined'
                            }
                            size="small"
                            startIcon={<EditIcon sx={{ fontSize: '1rem' }} />}
                            onClick={HandleEditModeToggle}
                            sx={{
                              minWidth: 'auto',
                              px: 1.5,
                              py: 0.75,
                              fontSize: '0.875rem',
                              lineHeight: 1.2,
                              whiteSpace: 'nowrap',
                              height: '36px',
                              backgroundColor: props.isEditMode
                                ? '#1976d2'
                                : 'transparent',
                              color: props.isEditMode ? 'white' : '#1976d2',
                              borderColor: props.isEditMode
                                ? '#1976d2'
                                : '#1976d2',
                              '& .MuiButton-startIcon': {
                                marginRight: 0.5,
                                marginLeft: 0,
                              },
                              '&:hover': {
                                backgroundColor: props.isEditMode
                                  ? '#1565c0'
                                  : '#e3f2fd',
                                borderColor: props.isEditMode
                                  ? '#1565c0'
                                  : '#1976d2',
                              },
                            }}
                          >
                            {props.isEditMode ? '편집 종료' : '편집'}
                          </Button>
                        </Tooltip>
                        {props.isEditMode &&
                          props.pendingDeleteCalendars.length > 0 && (
                            <>
                              <Tooltip title="삭제 취소">
                                <IconButton
                                  size="small"
                                  onClick={HandleCancelDelete}
                                  sx={{
                                    backgroundColor: '#ff9800',
                                    color: 'white',
                                    width: '36px',
                                    height: '36px',
                                    padding: '6px',
                                    '&:hover': {
                                      backgroundColor: '#f57c00',
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: '1.25rem',
                                    },
                                  }}
                                >
                                  <RefreshIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="삭제 확인">
                                <IconButton
                                  size="small"
                                  onClick={HandleConfirmDelete}
                                  sx={{
                                    backgroundColor: '#4caf50',
                                    color: 'white',
                                    width: '36px',
                                    height: '36px',
                                    padding: '6px',
                                    '&:hover': {
                                      backgroundColor: '#388e3c',
                                    },
                                    '& .MuiSvgIcon-root': {
                                      fontSize: '1.25rem',
                                    },
                                  }}
                                >
                                  <CheckIcon />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                      </Box>
                    </Box>
                  </Card>

                  {/* 삭제 대기 중인 캘린더 표시 */}
                  {props.isEditMode &&
                    props.pendingDeleteCalendars.length > 0 && (
                      <Card
                        sx={{
                          mb: 2,
                          p: 1.5,
                          backgroundColor: '#ffebee',
                          borderRadius: 2,
                          border: '1px solid #ffcdd2',
                          flexShrink: 0,
                          maxHeight: '200px',
                          overflow: 'hidden',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color="error"
                          sx={{
                            mb: 1,
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            flexShrink: 0,
                          }}
                        >
                          삭제 대기 중 ({props.pendingDeleteCalendars.length}개)
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            flex: 1,
                            minHeight: 0,
                            '&::-webkit-scrollbar': {
                              width: '6px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: 'rgba(0, 0, 0, 0.2)',
                              borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-track': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          {props.pendingDeleteCalendars.map((calendarId) => {
                            const calendar = props.myCalendars.find(
                              (cal) => cal.calId === calendarId
                            );
                            return (
                              <Box
                                key={calendarId}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.75,
                                  py: 0.5,
                                  px: 0.5,
                                  minHeight: '24px',
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 10,
                                    height: 10,
                                    backgroundColor: calendar?.color || '#ccc',
                                    borderRadius: '50%',
                                    flexShrink: 0,
                                    border: '1px solid rgba(0,0,0,0.1)',
                                  }}
                                />
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: '0.7rem',
                                    opacity: 0.7,
                                    textDecoration: 'line-through',
                                    flex: 1,
                                    minWidth: 0,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {calendar?.description || '알 수 없는 캘린더'}
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      </Card>
                    )}

                  {/* 내 캘린더 목록 표시 - Card 스타일로 개선 */}
                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      '&::-webkit-scrollbar': {
                        width: '12px',
                        height: '12px',
                        display: 'block',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0, 0, 0, 0.25)',
                        borderRadius: '6px',
                        border: '2px solid transparent',
                        backgroundClip: 'padding-box',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: '#e8e8e8',
                        borderRadius: '6px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                      }}
                    >
                      {props.myCalendars
                        ?.filter(
                          (calendar) =>
                            !props.pendingDeleteCalendars.includes(
                              calendar.calId
                            )
                        )
                        .map((calendar, index) => (
                          <Card
                            key={calendar.calId}
                            sx={{
                              p: 1.5,
                              backgroundColor: '#ffffff',
                              borderRadius: 2,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                              border: '1px solid #e0e0e0',
                              transition:
                                'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              '&:hover': {
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                // 첫 번째 항목은 위로 이동하지 않도록 처리
                                transform:
                                  index === 0 ? 'none' : 'translateY(-2px)',
                                borderColor: '#1976d2',
                              },
                            }}
                          >
                            {editingCalendarId === calendar.calId &&
                            calendar.mainCalendar !== 'Y' ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 1.5,
                                }}
                              >
                                <TextField
                                  value={
                                    editingDescriptions[calendar.calId] !==
                                    undefined
                                      ? editingDescriptions[calendar.calId]
                                      : calendar.description || ''
                                  }
                                  onChange={(e) =>
                                    setEditingDescriptions((prev) => ({
                                      ...prev,
                                      [calendar.calId]: e.target.value,
                                    }))
                                  }
                                  size="small"
                                  fullWidth
                                  autoFocus
                                  label="캘린더명"
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                      const description =
                                        editingDescriptions[calendar.calId] !==
                                        undefined
                                          ? editingDescriptions[calendar.calId]
                                          : calendar.description || '';
                                      if (description.trim()) {
                                        props.UpdateCalendarDescriptionLogic?.(
                                          calendar.calId,
                                          description.trim()
                                        );
                                        setEditingCalendarId(null);
                                        setEditingDescriptions((prev) => {
                                          const newState = { ...prev };
                                          delete newState[calendar.calId];
                                          return newState;
                                        });
                                      } else {
                                        dispatch(
                                          showSnackbar({
                                            message:
                                              '캘린더 이름을 입력하세요.',
                                            type: 'warning',
                                          })
                                        );
                                      }
                                    }
                                  }}
                                />
                                <Box
                                  sx={{
                                    display: 'flex',
                                    gap: 1,
                                    justifyContent: 'flex-end',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<CheckIcon />}
                                    onClick={() => {
                                      const description =
                                        editingDescriptions[calendar.calId] !==
                                        undefined
                                          ? editingDescriptions[calendar.calId]
                                          : calendar.description || '';
                                      if (description.trim()) {
                                        props.UpdateCalendarDescriptionLogic?.(
                                          calendar.calId,
                                          description.trim()
                                        );
                                        setEditingCalendarId(null);
                                        setEditingDescriptions((prev) => {
                                          const newState = { ...prev };
                                          delete newState[calendar.calId];
                                          return newState;
                                        });
                                      } else {
                                        dispatch(
                                          showSnackbar({
                                            message:
                                              '캘린더 이름을 입력하세요.',
                                            type: 'warning',
                                          })
                                        );
                                      }
                                    }}
                                  >
                                    저장
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<CloseIcon />}
                                    onClick={() => {
                                      setEditingCalendarId(null);
                                      setEditingDescriptions((prev) => {
                                        const newState = { ...prev };
                                        delete newState[calendar.calId];
                                        return newState;
                                      });
                                    }}
                                  >
                                    취소
                                  </Button>
                                </Box>
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1.5,
                                }}
                              >
                                {/* 편집 모드일 때는 삭제 버튼, 아닐 때는 체크박스 */}
                                {props.isEditMode ? (
                                  // 편집 모드: 삭제 버튼 (메인 캘린더는 삭제 불가)
                                  calendar.mainCalendar !== 'Y' &&
                                  !props.pendingDeleteCalendars.includes(
                                    calendar.calId
                                  ) ? (
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        HandleMarkForDelete(calendar.calId)
                                      }
                                      sx={{
                                        p: 0.5,
                                        color: 'error.main',
                                        '&:hover': {
                                          backgroundColor: 'error.light',
                                          color: 'white',
                                        },
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  ) : (
                                    <Box sx={{ width: 32 }} />
                                  )
                                ) : (
                                  // 일반 모드: 체크박스
                                  <Checkbox
                                    checked={calendar.checked}
                                    onChange={() =>
                                      HandleCalendarToggle(calendar.calId, true)
                                    }
                                    sx={{
                                      '&.Mui-checked': {
                                        color: '#1976d2',
                                      },
                                    }}
                                  />
                                )}
                                {/* 색상 표시 */}
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    backgroundColor:
                                      calendar.color || '#6aa84f',
                                    borderRadius: '50%',
                                    border: '2px solid #ffffff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                    flexShrink: 0,
                                    opacity:
                                      props.pendingDeleteCalendars.includes(
                                        calendar.calId
                                      )
                                        ? 0.5
                                        : 1,
                                  }}
                                />
                                {/* 캘린더명 */}
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: '0.95rem',
                                      color: 'text.primary',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      opacity:
                                        props.pendingDeleteCalendars.includes(
                                          calendar.calId
                                        )
                                          ? 0.5
                                          : 1,
                                      textDecoration:
                                        props.pendingDeleteCalendars.includes(
                                          calendar.calId
                                        )
                                          ? 'line-through'
                                          : 'none',
                                    }}
                                  >
                                    {calendar.description}
                                  </Typography>
                                  {calendar.mainCalendar === 'Y' && (
                                    <Chip
                                      label="메인"
                                      size="small"
                                      sx={{
                                        height: 18,
                                        fontSize: '0.65rem',
                                        backgroundColor: '#1976d2',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        mt: 0.5,
                                      }}
                                    />
                                  )}
                                </Box>
                                {/* 편집 버튼 - 편집 모드가 아니고 메인 캘린더가 아닐 때만 표시 */}
                                {!props.isEditMode &&
                                  calendar.mainCalendar !== 'Y' && (
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setEditingCalendarId(calendar.calId);
                                        setEditingDescriptions((prev) => ({
                                          ...prev,
                                          [calendar.calId]:
                                            calendar.description || '',
                                        }));
                                      }}
                                      sx={{
                                        color: '#1976d2',
                                        '&:hover': {
                                          backgroundColor: '#e3f2fd',
                                        },
                                      }}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                {!props.isEditMode &&
                                  calendar.mainCalendar === 'Y' && (
                                    <Tooltip title="메인 캘린더는 수정할 수 없습니다.">
                                      <IconButton
                                        size="small"
                                        disabled
                                        sx={{
                                          color: '#bdbdbd',
                                          cursor: 'not-allowed',
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </Box>
                            )}
                          </Card>
                        ))}
                      {(!props.myCalendars ||
                        props.myCalendars.length === 0) && (
                        <Card
                          sx={{
                            p: 4,
                            textAlign: 'center',
                            backgroundColor: '#fafafa',
                            borderRadius: 2,
                            border: '1px dashed #e0e0e0',
                          }}
                        >
                          <CalendarTodayIcon
                            sx={{
                              fontSize: 48,
                              color: 'text.secondary',
                              mb: 1,
                            }}
                          />
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontWeight: 500 }}
                          >
                            등록된 캘린더가 없습니다.
                          </Typography>
                        </Card>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}

              {/* 공유 캘린더 탭 */}
              {props.calendarManagementTab === 1 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    flex: 1,
                    overflow: 'hidden',
                  }}
                >
                  {/* 뷰 선택 영역 - Card로 감싸서 예쁘게 */}
                  <Card
                    sx={{
                      mb: 2,
                      p: 1,
                      backgroundColor: '#ffffff',
                      borderRadius: 3,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                      border: '1px solid #e8e8e8',
                    }}
                  >
                    <RadioGroup
                      row
                      value={props.favoriteCalendarView || 'myFavorites'}
                      onChange={(e) => {
                        props.setFavoriteCalendarView(e.target.value);
                        props.setSelectedCalendarManagementRows([]);
                        // 뷰 변경 시 데이터 조회
                        props.SearchCalendarManagementData?.(e.target.value);
                      }}
                      sx={{
                        display: 'flex',
                        gap: 1.5,
                      }}
                    >
                      <FormControlLabel
                        value="myFavorites"
                        control={
                          <Radio
                            sx={{
                              color:
                                props.favoriteCalendarView === 'myFavorites'
                                  ? '#1976d2'
                                  : '#bdbdbd',
                              '&.Mui-checked': {
                                color: '#1976d2',
                              },
                              '&:hover': {
                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                              },
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight:
                                props.favoriteCalendarView === 'myFavorites'
                                  ? 600
                                  : 400,
                              color:
                                props.favoriteCalendarView === 'myFavorites'
                                  ? '#1976d2'
                                  : '#616161',
                              fontSize: '0.875rem',
                              transition: 'all 0.2s ease',
                            }}
                          >
                            내가 등록한 공유 캘린더
                          </Typography>
                        }
                        sx={{
                          flex: 1,
                          margin: 0,
                          padding: '6px 12px',
                          borderRadius: 2.5,
                          backgroundColor:
                            props.favoriteCalendarView === 'myFavorites'
                              ? 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'
                              : '#fafafa',
                          border:
                            props.favoriteCalendarView === 'myFavorites'
                              ? '2px solid #1976d2'
                              : '2px solid #e0e0e0',
                          boxShadow:
                            props.favoriteCalendarView === 'myFavorites'
                              ? '0 4px 8px rgba(25, 118, 210, 0.2)'
                              : '0 1px 3px rgba(0,0,0,0.05)',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          cursor: 'pointer',
                          position: 'relative',
                          overflow: 'hidden',
                          '&::before':
                            props.favoriteCalendarView === 'myFavorites'
                              ? {
                                  content: '""',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  height: '3px',
                                  background:
                                    'linear-gradient(90deg, #1976d2, #42a5f5)',
                                }
                              : {},
                          '&:hover': {
                            backgroundColor:
                              props.favoriteCalendarView === 'myFavorites'
                                ? 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'
                                : '#f0f0f0',
                            borderColor:
                              props.favoriteCalendarView === 'myFavorites'
                                ? '#1976d2'
                                : '#bdbdbd',
                            boxShadow:
                              props.favoriteCalendarView === 'myFavorites'
                                ? '0 6px 12px rgba(25, 118, 210, 0.25)'
                                : '0 2px 6px rgba(0,0,0,0.1)',
                            transform: 'translateY(-1px)',
                          },
                          '& .MuiFormControlLabel-label': {
                            marginLeft: 1,
                            zIndex: 1,
                          },
                        }}
                      />
                      <FormControlLabel
                        value="viewingMe"
                        control={
                          <Radio
                            sx={{
                              color:
                                props.favoriteCalendarView === 'viewingMe'
                                  ? '#1976d2'
                                  : '#bdbdbd',
                              '&.Mui-checked': {
                                color: '#1976d2',
                              },
                              '&:hover': {
                                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                              },
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight:
                                props.favoriteCalendarView === 'viewingMe'
                                  ? 600
                                  : 400,
                              color:
                                props.favoriteCalendarView === 'viewingMe'
                                  ? '#1976d2'
                                  : '#616161',
                              fontSize: '0.875rem',
                              transition: 'all 0.2s ease',
                            }}
                          >
                            내 일정을 보고 있는 동료
                          </Typography>
                        }
                        sx={{
                          flex: 1,
                          margin: 0,
                          padding: '6px 12px',
                          borderRadius: 2.5,
                          backgroundColor:
                            props.favoriteCalendarView === 'viewingMe'
                              ? 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'
                              : '#fafafa',
                          border:
                            props.favoriteCalendarView === 'viewingMe'
                              ? '2px solid #1976d2'
                              : '2px solid #e0e0e0',
                          boxShadow:
                            props.favoriteCalendarView === 'viewingMe'
                              ? '0 4px 8px rgba(25, 118, 210, 0.2)'
                              : '0 1px 3px rgba(0,0,0,0.05)',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          cursor: 'pointer',
                          position: 'relative',
                          overflow: 'hidden',
                          '&::before':
                            props.favoriteCalendarView === 'viewingMe'
                              ? {
                                  content: '""',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  height: '3px',
                                  background:
                                    'linear-gradient(90deg, #1976d2, #42a5f5)',
                                }
                              : {},
                          '&:hover': {
                            backgroundColor:
                              props.favoriteCalendarView === 'viewingMe'
                                ? 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'
                                : '#f0f0f0',
                            borderColor:
                              props.favoriteCalendarView === 'viewingMe'
                                ? '#1976d2'
                                : '#bdbdbd',
                            boxShadow:
                              props.favoriteCalendarView === 'viewingMe'
                                ? '0 6px 12px rgba(25, 118, 210, 0.25)'
                                : '0 2px 6px rgba(0,0,0,0.1)',
                            transform: 'translateY(-1px)',
                          },
                          '& .MuiFormControlLabel-label': {
                            marginLeft: 1,
                            zIndex: 1,
                          },
                        }}
                      />
                    </RadioGroup>
                  </Card>

                  {/* 설명 및 버튼 영역 */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2,
                      p: 1.5,
                      backgroundColor: '#fafafa',
                      borderRadius: 1,
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontWeight: 500 }}
                    >
                      {props.favoriteCalendarView === 'myFavorites'
                        ? '내가 등록한 공유 캘린더 목록입니다.'
                        : '내 일정을 보고 있는 동료 목록입니다.'}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      {props.favoriteCalendarView === 'viewingMe' && (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<CheckIcon />}
                          size="small"
                          onClick={() => {
                            if (
                              !props.selectedCalendarManagementRows ||
                              props.selectedCalendarManagementRows.length === 0
                            ) {
                              dispatch(
                                showSnackbar({
                                  message: '수락할 항목을 선택하세요.',
                                  type: 'warning',
                                })
                              );
                              return;
                            }
                            props.setCalendarManagementConfirmAction('accept');
                            props.setCalendarManagementConfirmOpen(true);
                          }}
                        >
                          수락
                        </Button>
                      )}
                      <Button
                        variant="outlined"
                        color="error"
                        startIcon={<DeleteIcon />}
                        size="small"
                        onClick={() => {
                          if (
                            !props.selectedCalendarManagementRows ||
                            props.selectedCalendarManagementRows.length === 0
                          ) {
                            const actionText =
                              props.favoriteCalendarView === 'viewingMe'
                                ? '거절'
                                : '삭제';
                            dispatch(
                              showSnackbar({
                                message: `${actionText}할 항목을 선택하세요.`,
                                type: 'warning',
                              })
                            );
                            return;
                          }
                          props.setCalendarManagementConfirmAction('delete');
                          props.setCalendarManagementConfirmOpen(true);
                        }}
                      >
                        {props.favoriteCalendarView === 'viewingMe'
                          ? '삭제(거절)'
                          : '삭제'}
                      </Button>
                    </Box>
                  </Box>

                  {/* 테이블 영역 - 고정 높이와 스크롤 */}
                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden',
                    }}
                  >
                    <TableContainer
                      component={Paper}
                      sx={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: 'scroll',
                        overflowX: 'auto',
                        border: '1px solid #e0e0e0',
                        borderRadius: 1,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        '&::-webkit-scrollbar': {
                          width: '12px',
                          height: '12px',
                          display: 'block',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: 'rgba(0, 0, 0, 0.25)',
                          borderRadius: '6px',
                          border: '2px solid transparent',
                          backgroundClip: 'padding-box',
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor: '#e8e8e8',
                          borderRadius: '6px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        },
                        '&::-webkit-scrollbar-thumb:active': {
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        },
                      }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox" width={50}>
                              <Checkbox
                                indeterminate={
                                  props.selectedCalendarManagementRows?.length >
                                    0 &&
                                  props.selectedCalendarManagementRows?.length <
                                    (props.calendarManagementData?.length || 0)
                                }
                                checked={
                                  props.calendarManagementData?.length > 0 &&
                                  props.selectedCalendarManagementRows
                                    ?.length ===
                                    props.calendarManagementData?.length
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    props.setSelectedCalendarManagementRows(
                                      props.calendarManagementData || []
                                    );
                                  } else {
                                    props.setSelectedCalendarManagementRows([]);
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell>이름</TableCell>
                            <TableCell>캘린더</TableCell>
                            <TableCell>상태</TableCell>
                            <TableCell>설정일</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {props.calendarManagementData?.length > 0 ? (
                            props.calendarManagementData.map((row, index) => {
                              const isSelected =
                                props.selectedCalendarManagementRows?.some(
                                  (item) =>
                                    (item.calMId || item.id) ===
                                    (row.calMId || row.id)
                                );
                              return (
                                <TableRow key={row.calMId || row.id || index}>
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          props.setSelectedCalendarManagementRows(
                                            [
                                              ...(props.selectedCalendarManagementRows ||
                                                []),
                                              row,
                                            ]
                                          );
                                        } else {
                                          props.setSelectedCalendarManagementRows(
                                            (
                                              props.selectedCalendarManagementRows ||
                                              []
                                            ).filter(
                                              (item) =>
                                                (item.calMId || item.id) !==
                                                (row.calMId || row.id)
                                            )
                                          );
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>{row.name || ''}</TableCell>
                                  <TableCell>
                                    {row.calendarName ||
                                      row.CalendarNm ||
                                      row.description ||
                                      '내 일정'}
                                  </TableCell>
                                  <TableCell>
                                    {row.STATUS || row.status || '신청대기'}
                                  </TableCell>
                                  <TableCell>
                                    {row.SETUP_DATE || row.setupDate
                                      ? dayjs(
                                          row.SETUP_DATE || row.setupDate
                                        ).format('YYYY-MM-DD')
                                      : ''}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell colSpan={5} align="center">
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  데이터가 없습니다.
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              )}
              </Box>
            </Box>
          }
        />

        {/* 캘린더 관리 확인 Dialog */}
        <Dialog
          title={null}
          titleSx={{ display: 'none', p: 0, m: 0, height: 0, minHeight: 0 }}
          open={props.calendarManagementConfirmOpen || false}
          onClose={() => {
            props.setCalendarManagementConfirmOpen(false);
            props.setCalendarManagementConfirmAction(null);
          }}
          maxWidth="xs"
          fullWidth
          contentSx={{
            p: '0 !important',
            overflow: 'hidden',
            '&.MuiDialogContent-root': {
              padding: '0 !important',
            },
          }}
          useSaveButton={false}
          useCloseButton={false}
          content={
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              {/* Header */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  bgcolor: 'white',
                  borderBottom: '1px solid #e0e0e0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: '8px',
                      backgroundColor:
                        props.calendarManagementConfirmAction === 'accept'
                          ? 'rgba(76, 175, 80, 0.1)'
                          : 'rgba(244, 67, 54, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {props.calendarManagementConfirmAction === 'accept' ? (
                      <CheckIcon sx={{ color: '#4caf50', fontSize: 20 }} />
                    ) : (
                      <DeleteIcon sx={{ color: '#f44336', fontSize: 20 }} />
                    )}
                  </Box>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: 18, color: '#111418' }}
                  >
                    {props.calendarManagementConfirmAction === 'accept'
                      ? '신청 수락'
                      : props.favoriteCalendarView === 'viewingMe'
                        ? '거절 확인'
                        : '삭제 확인'}
                  </Typography>
                </Box>
                <IconButton
                  onClick={() => {
                    props.setCalendarManagementConfirmOpen(false);
                    props.setCalendarManagementConfirmAction(null);
                  }}
                  size="small"
                  sx={{ color: '#637588' }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Paper>

              {/* Content */}
              <Box sx={{ p: 3, bgcolor: '#f6f7f8' }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    sx={{ fontSize: 15, color: '#333', lineHeight: 1.6 }}
                  >
                    {props.calendarManagementConfirmAction === 'accept'
                      ? `선택한 ${props.selectedCalendarManagementRows?.length || 0}개의 신청을 수락하시겠습니까?`
                      : `선택한 ${props.selectedCalendarManagementRows?.length || 0}개의 항목을 ${
                          props.favoriteCalendarView === 'viewingMe'
                            ? '거절'
                            : '삭제'
                        }하시겠습니까?`}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: '#888', mt: 1 }}>
                    {props.calendarManagementConfirmAction === 'accept'
                      ? '수락 시 해당 사용자가 캘린더를 공유받게 됩니다.'
                      : props.favoriteCalendarView === 'viewingMe'
                        ? '거절 시 해당 사용자의 공유 신청이 취소됩니다.'
                        : '삭제된 항목은 복구할 수 없습니다.'}
                  </Typography>
                </Paper>
              </Box>

              {/* Footer */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  bgcolor: 'white',
                  borderTop: '1px solid #e0e0e0',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 1,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    props.setCalendarManagementConfirmOpen(false);
                    props.setCalendarManagementConfirmAction(null);
                  }}
                  sx={{
                    color: '#637588',
                    borderColor: '#dbe0e6',
                    '&:hover': {
                      borderColor: '#637588',
                      backgroundColor: 'rgba(99, 117, 136, 0.04)',
                    },
                  }}
                >
                  취소
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (props.calendarManagementConfirmAction === 'accept') {
                      props.AcceptCalendarManagementData?.(
                        props.selectedCalendarManagementRows
                      );
                    } else {
                      props.DeleteCalendarManagementData?.(
                        props.selectedCalendarManagementRows
                      );
                    }
                    props.setCalendarManagementConfirmOpen(false);
                    props.setCalendarManagementConfirmAction(null);
                  }}
                  sx={{
                    backgroundColor:
                      props.calendarManagementConfirmAction === 'accept'
                        ? '#4caf50'
                        : '#f44336',
                    '&:hover': {
                      backgroundColor:
                        props.calendarManagementConfirmAction === 'accept'
                          ? '#388e3c'
                          : '#d32f2f',
                    },
                  }}
                >
                  {props.calendarManagementConfirmAction === 'accept'
                    ? '수락'
                    : props.favoriteCalendarView === 'viewingMe'
                      ? '거절'
                      : '삭제'}
                </Button>
              </Paper>
            </Box>
          }
        />
      </Box>
    </LocalizationProvider>
  );
}

export default SCH_BASIC;
